import React, {
    useCallback,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";

import {
   FaDownload,
     FaPaperclip,
   } from "react-icons/fa";

import {
    FaBookOpen,
    FaBullhorn,
    FaCheckCircle,
    FaChevronDown,
    FaChevronLeft,
    FaChevronRight,
    FaClock,
    FaEdit,
    FaExclamationTriangle,
    FaFileAlt,
    FaGraduationCap,
    FaLayerGroup,
    FaPlay,
    FaPlus,
    FaQuestionCircle,
    FaSave,
    FaSearch,
    FaStar,
    FaTrash,
    FaUpload,
    FaVideo,
    FaTimes,
} from "react-icons/fa";

import Swal from "sweetalert2";

import api from "../../../api/api";

import ViewCoursesEdit from "./ViewCoursesEdit";

const ViewCourses = () => {
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);

    const [classroom, setClassroom] = useState(null);
    const [videoSections, setVideoSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(null);
    const [sectionClassroom, setSectionClassroom] = useState(null);

    const [loading, setLoading] = useState(true);
    const [classroomLoading, setClassroomLoading] = useState(false);
    const [sectionsLoading, setSectionsLoading] = useState(false);
    const [sectionClassroomLoading, setSectionClassroomLoading] =
        useState(false);

    const [deletingCourse, setDeletingCourse] = useState(false);
    const [deletingSection, setDeletingSection] = useState(false);
    const [uploadingSection, setUploadingSection] = useState(false);
    const [updatingSection, setUpdatingSection] = useState(false);

    const [activeEditor, setActiveEditor] = useState("overview");
    const [activeSectionEditor, setActiveSectionEditor] =
        useState("overview");

    const [overview, setOverview] = useState("");

    const [announcementTitle, setAnnouncementTitle] = useState("");
    const [announcementContent, setAnnouncementContent] = useState("");

    const [review, setReview] = useState("");

    const [sectionOverview, setSectionOverview] = useState("");
    const [sectionAnnouncementTitle, setSectionAnnouncementTitle] =
        useState("");
    const [sectionAnnouncementContent, setSectionAnnouncementContent] =
        useState("");
    const [sectionReview, setSectionReview] = useState("");

    const [savingOverview, setSavingOverview] = useState(false);
    const [savingAnnouncement, setSavingAnnouncement] = useState(false);
    const [savingReview, setSavingReview] = useState(false);

    const [savingSectionOverview, setSavingSectionOverview] = useState(false);
    const [savingSectionAnnouncement, setSavingSectionAnnouncement] =
        useState(false);
    const [savingSectionReview, setSavingSectionReview] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);

    const [totalCourses, setTotalCourses] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    const [pageSize] = useState(10);

    const [editCourse, setEditCourse] = useState(null);

    const [showSectionUploader, setShowSectionUploader] = useState(false);
    const [sectionTitle, setSectionTitle] = useState("");
    const [sectionDescription, setSectionDescription] = useState("");
    const [sectionVideoFile, setSectionVideoFile] = useState(null);

    const [editingSectionId, setEditingSectionId] = useState(null);
    const [editingSectionTitle, setEditingSectionTitle] = useState("");
    const [editingSectionDescription, setEditingSectionDescription] =
        useState("");
    const [editingSectionVideoFile, setEditingSectionVideoFile] =
        useState(null);

    const sectionFileInputRef = useRef(null);
    const editSectionFileInputRef = useRef(null);

    const token = localStorage.getItem("access");

    const headers = useMemo(
        () => ({
            Authorization: `Bearer ${token}`,
        }),
        [token]
    );

    // Resource Attashment Edit Starts PDF

    const RESOURCE_MAX_SIZE = 50 * 1024 * 1024;

const RESOURCE_EXTENSIONS = [
    ".pdf",
    ".doc",
    ".docx",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx",
    ".csv",
    ".txt",
];

const [sectionResources, setSectionResources] = useState({});
const [sectionResourceFiles, setSectionResourceFiles] = useState({});
const [sectionResourceTitles, setSectionResourceTitles] = useState({});
const [sectionResourceDescriptions, setSectionResourceDescriptions] =
    useState({});
const [sectionResourcesLoading, setSectionResourcesLoading] = useState({});
const [sectionResourceUploading, setSectionResourceUploading] = useState({});
const [sectionResourceDeleting, setSectionResourceDeleting] = useState({});
const [openResourceSectionId, setOpenResourceSectionId] = useState(null);

const getResourceExtension = (fileName = "") => {
    const value = String(fileName).toLowerCase();
    const index = value.lastIndexOf(".");

    return index >= 0 ? value.substring(index) : "";
};

const formatResourceSize = (size) => {
    const numericSize = Number(size || 0);

    return `${(numericSize / 1024 / 1024).toFixed(2)} MB`;
};

const getResourceName = (resource) => {
    return (
        resource?.original_filename ||
        resource?.file_name ||
        resource?.filename ||
        resource?.name ||
        resource?.title ||
        "Learning Resource"
    );
};

const getResourceUrl = (resource) => {
    return (
        resource?.download_url ||
        resource?.file_url ||
        resource?.file ||
        ""
    );
};

const resolveResourceUrl = (value) => {
    if (!value) {
        return "";
    }

    if (
        String(value).startsWith("http://") ||
        String(value).startsWith("https://") ||
        String(value).startsWith("blob:")
    ) {
        return value;
    }

    try {
        const baseUrl = api.defaults.baseURL || window.location.origin;
        const origin = new URL(baseUrl, window.location.origin).origin;

        if (String(value).startsWith("/")) {
            return `${origin}${value}`;
        }

        return `${String(baseUrl).replace(/\/+$/, "")}/${String(
            value
        ).replace(/^\/+/, "")}`;
    } catch {
        return value;
    }
};

const fetchSectionResources = async (section) => {
    if (!selectedCourse?.id || !section?.id) {
        return;
    }

    const sectionId = section.id;

    setSectionResourcesLoading((previous) => ({
        ...previous,
        [sectionId]: true,
    }));

    try {
        const response = await api.get(
            `api/users/subjects/${selectedCourse.id}/video-sections/${sectionId}/resources/`
        );

        const data = Array.isArray(response.data)
            ? response.data
            : response.data?.results || [];

        setSectionResources((previous) => ({
            ...previous,
            [sectionId]: data,
        }));
    } catch (error) {
        console.error(
            "Failed to load video section resources:",
            error
        );

        showCayepAlert({
            type: "warning",
            title: "Resources Unavailable",
            text: "The learning resources for this video could not be loaded.",
        });
    } finally {
        setSectionResourcesLoading((previous) => ({
            ...previous,
            [sectionId]: false,
        }));
    }
};

const uploadSectionResource = async (section) => {
    if (!selectedCourse?.id || !section?.id) {
        return;
    }

    const sectionId = section.id;
    const file = sectionResourceFiles[sectionId];

    if (!file) {
        showCayepAlert({
            type: "warning",
            title: "Resource Required",
            text: "Please select a PDF, Word, Excel, PowerPoint, CSV, or TXT file.",
        });

        return;
    }

    const extension = getResourceExtension(file.name);

    if (!RESOURCE_EXTENSIONS.includes(extension)) {
        showCayepAlert({
            type: "warning",
            title: "Unsupported File",
            text:
                "Allowed files are PDF, Word, Excel, PowerPoint, CSV and TXT.",
        });

        return;
    }

    if (file.size > RESOURCE_MAX_SIZE) {
        showCayepAlert({
            type: "warning",
            title: "File Too Large",
            text: "Learning resources cannot be larger than 50 MB.",
        });

        return;
    }

    const title = String(
        sectionResourceTitles[sectionId] ||
            file.name.replace(/\.[^/.]+$/, "")
    ).trim();

    if (!title) {
        showCayepAlert({
            type: "warning",
            title: "Resource Title Required",
            text: "Please enter a title for this learning resource.",
        });

        return;
    }

    setSectionResourceUploading((previous) => ({
        ...previous,
        [sectionId]: true,
    }));

    try {
        const formData = new FormData();

        formData.append("file", file, file.name);
        formData.append("title", title);
        formData.append(
            "description",
            String(sectionResourceDescriptions[sectionId] || "").trim()
        );

        await api.post(
            `api/users/subjects/${selectedCourse.id}/video-sections/${sectionId}/resources/`,
            formData
        );

        showCayepAlert({
            type: "success",
            title: "Resource Uploaded",
            text: `The learning resource has been attached to Video ${getSectionNumber(
                section
            )}.`,
            timer: 1800,
            showConfirmButton: false,
        });

        setSectionResourceFiles((previous) => ({
            ...previous,
            [sectionId]: null,
        }));

        setSectionResourceTitles((previous) => ({
            ...previous,
            [sectionId]: "",
        }));

        setSectionResourceDescriptions((previous) => ({
            ...previous,
            [sectionId]: "",
        }));

        await fetchSectionResources(section);
    } catch (error) {
        console.error(
            "Failed to upload video section resource:",
            error
        );

        showCayepAlert({
            type: "error",
            title: "Upload Failed",
            text:
                error?.response?.data?.detail ||
                "The learning resource could not be uploaded.",
        });
    } finally {
        setSectionResourceUploading((previous) => ({
            ...previous,
            [sectionId]: false,
        }));
    }
};

const deleteSectionResource = async (section, resource) => {
    if (!selectedCourse?.id || !section?.id || !resource?.id) {
        return;
    }

    const result = await Swal.fire({
        title: "Delete Resource?",
        text: `Remove "${getResourceName(resource)}" from Video ${getSectionNumber(
            section
        )}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete Resource",
        cancelButtonText: "Cancel",
        background: "#F4F7F9",
        color: "#142536",
        confirmButtonColor: "#C62828",
        cancelButtonColor: "#062A4B",
        customClass: {
            popup: "cayep-swal-popup",
            title: "cayep-swal-title",
            htmlContainer: "cayep-swal-text",
            confirmButton: "cayep-swal-confirm",
        },
    });

    if (!result.isConfirmed) {
        return;
    }

    setSectionResourceDeleting((previous) => ({
        ...previous,
        [resource.id]: true,
    }));

    try {
        await api.delete(
            `api/users/subjects/${selectedCourse.id}/video-sections/${section.id}/resources/${resource.id}/`
        );

        setSectionResources((previous) => ({
            ...previous,
            [section.id]: (
                previous[section.id] || []
            ).filter(
                (item) => item.id !== resource.id
            ),
        }));

        showCayepAlert({
            type: "success",
            title: "Resource Deleted",
            text: "The learning resource has been removed.",
            timer: 1600,
            showConfirmButton: false,
        });
    } catch (error) {
        console.error(
            "Failed to delete video section resource:",
            error
        );

        showCayepAlert({
            type: "error",
            title: "Delete Failed",
            text:
                error?.response?.data?.detail ||
                "The learning resource could not be deleted.",
        });
    } finally {
        setSectionResourceDeleting((previous) => ({
            ...previous,
            [resource.id]: false,
        }));
    }
};

const showCayepAlert = ({
    type = "info",
    title = "",
    text = "",
    timer = null,
    showConfirmButton = true,
}) => {
    const alertColors = {
        success: {
            accent: "#4FAE22",
            background: "#F4FAEF",
        },
        error: {
            accent: "#C62828",
            background: "#FFF5F5",
        },
        warning: {
            accent: "#EFA81C",
            background: "#FFF9E8",
        },
        info: {
            accent: "#0F6DAB",
            background: "#F2F8FC",
        },
    };

    const colors =
        alertColors[type] || alertColors.info;

    Swal.fire({
        title,
        text,
        icon: type,
        background: colors.background,
        color: "#142536",
        confirmButtonColor: "#062A4B",
        showConfirmButton,
        timer: timer || undefined,
        timerProgressBar: Boolean(timer),
        buttonsStyling: true,
        customClass: {
            popup: "cayep-swal-popup",
            title: "cayep-swal-title",
            htmlContainer: "cayep-swal-text",
            confirmButton: "cayep-swal-confirm",
        },
        didOpen: (popup) => {
            popup.style.borderTop =
                `5px solid ${colors.accent}`;

            popup.style.boxShadow =
                "0 18px 50px rgba(6,42,75,0.18)";
        },
    });
};

    // Resource Attachment Edit Ends PDF

    const getCurrentUserRole = useCallback(() => {
        const directRole =
            localStorage.getItem("role") ||
            localStorage.getItem("user_role");

        if (directRole) {
            return directRole
                .trim()
                .toLowerCase()
                .replace(/[\s_-]+/g, "");
        }

        const storedUser = localStorage.getItem("user");

        if (!storedUser) {
            return "";
        }

        try {
            const parsedUser = JSON.parse(storedUser);

            return String(
                parsedUser?.role ||
                    parsedUser?.user_role ||
                    parsedUser?.user_type ||
                    parsedUser?.type ||
                    ""
            )
                .trim()
                .toLowerCase()
                .replace(/[\s_-]+/g, "");
        } catch (error) {
            return "";
        }
    }, []);

    const userRole = getCurrentUserRole();

    const isAdmin = [
        "admin",
        "administrator",
    ].includes(userRole);

    const isPrincipal = userRole === "principal";

    const isTeacher = [
        "teacher",
        "facilitator",
        "instructor",
    ].includes(userRole);

    const canDeleteCourses =
        isAdmin || isPrincipal;

    const canEditCourses =
        isAdmin ||
        isPrincipal ||
        isTeacher;

    const canManageSections =
        isAdmin ||
        isPrincipal ||
        isTeacher;

    const getMediaUrl = useCallback((value) => {
        if (!value) {
            return "";
        }

        const stringValue = String(value);

        if (
            stringValue.startsWith("http://") ||
            stringValue.startsWith("https://") ||
            stringValue.startsWith("blob:")
        ) {
            return stringValue;
        }

        if (stringValue.startsWith("/")) {
            return stringValue;
        }

        return `/${stringValue}`;
    }, []);

    const escapeHtml = useCallback((value = "") => {
        return String(value)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }, []);

    const showSuccessAlert = useCallback(
        ({
            title,
            text = "",
        }) => {
            Swal.fire({
                icon: "success",
                title,
                text,
                timer: 1700,
                showConfirmButton: false,
                background: "#07131d",
                color: "#F0EDEA",
                iconColor: "#8FD06E",
                customClass: {
                    popup: "cayep-swal-popup",
                    title: "cayep-swal-title",
                    htmlContainer: "cayep-swal-text",
                },
            });
        },
        []
    );

    const showErrorAlert = useCallback(
        ({
            title,
            text = "Please try again.",
        }) => {
            Swal.fire({
                icon: "error",
                title,
                text,
                background: "#07131d",
                color: "#F0EDEA",
                iconColor: "#E57373",
                confirmButtonText: "Close",
                buttonsStyling: false,
                customClass: {
                    popup: "cayep-swal-popup",
                    title: "cayep-swal-title",
                    htmlContainer: "cayep-swal-text",
                    confirmButton:
                        "cayep-swal-button cayep-swal-button-danger",
                },
            });
        },
        []
    );

    const getBackendError = useCallback((error, fallback) => {
        const data = error?.response?.data;

        if (!data) {
            return fallback;
        }

        if (typeof data === "string") {
            return data;
        }

        if (data.detail) {
            return String(data.detail);
        }

        if (data.message) {
            return String(data.message);
        }

        if (data.error) {
            return String(data.error);
        }

        const messages = [];

        Object.entries(data).forEach(([field, value]) => {
            if (Array.isArray(value)) {
                value.forEach((item) => {
                    messages.push(
                        `${field}: ${String(item)}`
                    );
                });
            } else if (
                value !== null &&
                value !== undefined
            ) {
                messages.push(
                    `${field}: ${String(value)}`
                );
            }
        });

        return messages.length
            ? messages.join("\n")
            : fallback;
    }, []);

    const normalizeResults = useCallback((data) => {
        if (Array.isArray(data)) {
            return data;
        }

        if (Array.isArray(data?.results)) {
            return data.results;
        }

        if (Array.isArray(data?.data)) {
            return data.data;
        }

        return [];
    }, []);

    const normalizeDurationSeconds = useCallback((item) => {
        if (!item) {
            return 0;
        }

        const candidates = [
            item.duration_seconds,
            item.video_duration_seconds,
            item.durationSeconds,
        ];

        for (const candidate of candidates) {
            const value = Number(candidate);

            if (
                Number.isFinite(value) &&
                value > 0
            ) {
                return Math.round(value);
            }
        }

        return 0;
    }, []);

    const formatDuration = useCallback((seconds) => {
        const totalSeconds = Math.max(
            0,
            Math.round(Number(seconds) || 0)
        );

        if (!totalSeconds) {
            return "Duration unavailable";
        }

        const hours = Math.floor(
            totalSeconds / 3600
        );

        const minutes = Math.floor(
            (totalSeconds % 3600) / 60
        );

        const remainingSeconds =
            totalSeconds % 60;

        if (hours > 0) {
            return `${hours}h ${String(
                minutes
            ).padStart(2, "0")}m`;
        }

        if (minutes > 0) {
            return `${minutes}m ${
                remainingSeconds
            }s`;
        }

        return `${remainingSeconds}s`;
    }, []);

    const getCourseVideoCount = useCallback(
        (course, sections = []) => {
            const hasMainVideo = Boolean(
                course?.video
            );

            return (
                (hasMainVideo ? 1 : 0) +
                sections.length
            );
        },
        []
    );

    const getCourseTotalDuration = useCallback(
        (course, sections = []) => {
            const mainDuration = Number(
                course?.video_duration_seconds
            ) || 0;

            const sectionsDuration =
                sections.reduce(
                    (total, section) =>
                        total +
                        normalizeDurationSeconds(
                            section
                        ),
                    0
                );

            return (
                mainDuration +
                sectionsDuration
            );
        },
        [normalizeDurationSeconds]
    );

    const getSectionNumber = useCallback(
        (section) => {
            const number = Number(
                section?.section_number
            );

            return Number.isFinite(number)
                ? number
                : 0;
        },
        []
    );

    const showTeacherDeleteDeniedAlert =
        useCallback(() => {
            Swal.fire({
                icon: "warning",
                title: "Delete Permission Required",
                html: `
                    <div class="cayep-swal-message">
                        <div class="cayep-swal-icon-wrap">
                            <span>🔒</span>
                        </div>

                        <p>
                            Your teacher account can
                            <strong>edit and update courses</strong>,
                            but it does not have permission to
                            delete courses.
                        </p>

                        <div class="cayep-swal-notice">
                            <span>ADMINISTRATOR ACCESS</span>
                            <strong>
                                Please contact an Admin or Principal
                                if this course needs to be deleted.
                            </strong>
                        </div>
                    </div>
                `,
                background: "#07131d",
                color: "#F0EDEA",
                iconColor: "#F6C944",
                confirmButtonText: "Understood",
                buttonsStyling: false,
                customClass: {
                    popup:
                        "cayep-swal-popup cayep-swal-permission-popup",
                    title: "cayep-swal-title",
                    htmlContainer: "cayep-swal-html",
                    confirmButton:
                        "cayep-swal-button cayep-swal-button-warning",
                },
            });
        }, []);

    const confirmCourseDelete = useCallback(
        async (course) => {
            if (!course?.id) {
                return false;
            }

            if (!canDeleteCourses) {
                showTeacherDeleteDeniedAlert();
                return false;
            }

            const courseName =
                course.name ||
                course.title ||
                course.subject_name ||
                "Selected Course";

            const result = await Swal.fire({
                icon: "warning",
                title: "Delete Course?",
                html: `
                    <div class="cayep-swal-message">
                        <div class="cayep-delete-course-name">
                            ${escapeHtml(courseName)}
                        </div>

                        <p>
                            You are about to permanently delete
                            this course.
                        </p>

                        <p>
                            Course classroom information and
                            associated video content may be
                            affected according to the backend
                            relationships.
                        </p>

                        <div class="cayep-swal-warning-box">
                            <span>⚠</span>
                            <strong>
                                This action cannot be undone.
                            </strong>
                        </div>
                    </div>
                `,
                background: "#07131d",
                color: "#F0EDEA",
                iconColor: "#EFA81C",
                showCancelButton: true,
                confirmButtonText: "Yes, Delete Course",
                cancelButtonText: "Keep Course",
                reverseButtons: true,
                focusCancel: true,
                buttonsStyling: false,
                customClass: {
                    popup:
                        "cayep-swal-popup cayep-swal-delete-popup",
                    title: "cayep-swal-title",
                    htmlContainer: "cayep-swal-html",
                    confirmButton:
                        "cayep-swal-button cayep-swal-button-danger",
                    cancelButton:
                        "cayep-swal-button cayep-swal-button-cancel",
                },
            });

            return result.isConfirmed;
        },
        [
            canDeleteCourses,
            escapeHtml,
            showTeacherDeleteDeniedAlert,
        ]
    );

    const loadCourses = useCallback(
        async (
            requestedPage = 1,
            requestedSearch = ""
        ) => {
            try {
                setLoading(true);

                const response = await api.get(
                    "api/users/subjects/teacher-courses/",
                    {
                        headers,
                        params: {
                            page: requestedPage,
                            page_size: pageSize,
                            search:
                                requestedSearch.trim(),
                        },
                    }
                );

                const data = response.data || {};

                const results =
                    normalizeResults(data);

                setCourses(results);

                const count = Number(
                    data?.count ?? results.length
                );

                setTotalCourses(
                    Number.isFinite(count)
                        ? count
                        : results.length
                );

                const calculatedPages =
                    Math.max(
                        1,
                        Math.ceil(
                            count / pageSize
                        )
                    );

                setTotalPages(
                    calculatedPages
                );

                if (
                    requestedPage >
                    calculatedPages
                ) {
                    setPage(calculatedPages);
                }
            } catch (error) {
                console.error(
                    "Teacher courses error:",
                    error
                );

                showErrorAlert({
                    title: "Unable to load courses",
                    text: getBackendError(
                        error,
                        "Please try again."
                    ),
                });
            } finally {
                setLoading(false);
            }
        },
        [
            getBackendError,
            headers,
            normalizeResults,
            pageSize,
            showErrorAlert,
        ]
    );

    const loadVideoSections = useCallback(
        async (courseId) => {
            if (!courseId) {
                setVideoSections([]);
                return [];
            }

            try {
                setSectionsLoading(true);

                const response = await api.get(
                    `api/users/subjects/${courseId}/video-sections/`,
                    {
                        headers,
                    }
                );

                const results =
                    normalizeResults(
                        response.data
                    );

                const sorted = [
                    ...results,
                ].sort(
                    (a, b) =>
                        getSectionNumber(a) -
                            getSectionNumber(b) ||
                        Number(a?.id || 0) -
                            Number(b?.id || 0)
                );

                setVideoSections(sorted);

                return sorted;
            } catch (error) {
                console.error(
                    "Video sections error:",
                    error
                );

                setVideoSections([]);

                showErrorAlert({
                    title:
                        "Unable to load course videos",
                    text: getBackendError(
                        error,
                        "The course videos could not be loaded."
                    ),
                });

                return [];
            } finally {
                setSectionsLoading(false);
            }
        },
        [
            getBackendError,
            getSectionNumber,
            headers,
            normalizeResults,
            showErrorAlert,
        ]
    );

    const loadClassroom = useCallback(
        async (course) => {
            if (!course?.id) {
                return;
            }

            try {
                setClassroomLoading(true);

                setSelectedCourse(course);
                setSelectedSection(null);
                setSectionClassroom(null);
                setVideoSections([]);
                setActiveEditor("overview");
                setActiveSectionEditor(
                    "overview"
                );

                const [
                    classroomResponse,
                    sections,
                ] = await Promise.all([
                    api.get(
                        `api/users/subjects/${course.id}/classroom/`,
                        {
                            headers,
                        }
                    ),
                    loadVideoSections(
                        course.id
                    ),
                ]);

                const data =
                    classroomResponse.data ||
                    {};

                setClassroom(data);

                setOverview(
                    data?.overview?.content ||
                        ""
                );

                setAnnouncementTitle("");
                setAnnouncementContent("");
                setReview("");

                setVideoSections(
                    sections
                );
            } catch (error) {
                console.error(
                    "Classroom loading error:",
                    error
                );

                showErrorAlert({
                    title:
                        "Unable to load classroom",
                    text: getBackendError(
                        error,
                        "Please try again."
                    ),
                });
            } finally {
                setClassroomLoading(false);
            }
        },
        [
            getBackendError,
            headers,
            loadVideoSections,
            showErrorAlert,
        ]
    );

    useEffect(() => {
        loadCourses(1, "");
    }, [loadCourses]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setPage(1);

            loadCourses(
                1,
                searchTerm
            );
        }, 350);

        return () =>
            clearTimeout(timer);
    }, [
        searchTerm,
        loadCourses,
    ]);

    const handlePageChange = useCallback(
        (nextPage) => {
            if (
                nextPage < 1 ||
                nextPage > totalPages ||
                nextPage === page
            ) {
                return;
            }

            setPage(nextPage);

            loadCourses(
                nextPage,
                searchTerm
            );
        },
        [
            loadCourses,
            page,
            searchTerm,
            totalPages,
        ]
    );

    const saveOverview = async () => {
        if (
            !selectedCourse ||
            !overview.trim()
        ) {
            return;
        }

        try {
            setSavingOverview(true);

            const response = await api.post(
                `api/users/subjects/${selectedCourse.id}/overview/`,
                {
                    content:
                        overview.trim(),
                },
                {
                    headers,
                }
            );

            setClassroom(
                (previous) => ({
                    ...previous,
                    overview:
                        response.data,
                })
            );

            showSuccessAlert({
                title:
                    "Overview Published",
            });
        } catch (error) {
            showErrorAlert({
                title:
                    "Unable to save overview",
                text: getBackendError(
                    error,
                    "Please try again."
                ),
            });
        } finally {
            setSavingOverview(false);
        }
    };

    const publishAnnouncement =
        async () => {
            if (
                !selectedCourse ||
                !announcementTitle.trim() ||
                !announcementContent.trim()
            ) {
                return;
            }

            try {
                setSavingAnnouncement(
                    true
                );

                const response =
                    await api.post(
                        `api/users/subjects/${selectedCourse.id}/announcements/`,
                        {
                            title:
                                announcementTitle.trim(),
                            content:
                                announcementContent.trim(),
                        },
                        {
                            headers,
                        }
                    );

                setClassroom(
                    (previous) => ({
                        ...previous,
                        announcements: [
                            response.data,
                            ...(previous
                                ?.announcements ||
                                []),
                        ],
                    })
                );

                setAnnouncementTitle(
                    ""
                );

                setAnnouncementContent(
                    ""
                );

                showSuccessAlert({
                    title:
                        "Announcement Published",
                });
            } catch (error) {
                showErrorAlert({
                    title:
                        "Unable to publish announcement",
                    text: getBackendError(
                        error,
                        "Please try again."
                    ),
                });
            } finally {
                setSavingAnnouncement(
                    false
                );
            }
        };

    const publishReview = async () => {
        if (
            !selectedCourse ||
            !review.trim()
        ) {
            return;
        }

        try {
            setSavingReview(true);

            const response =
                await api.post(
                    `api/users/subjects/${selectedCourse.id}/reviews/`,
                    {
                        content:
                            review.trim(),
                    },
                    {
                        headers,
                    }
                );

            setClassroom(
                (previous) => ({
                    ...previous,
                    reviews: [
                        response.data,
                        ...(previous?.reviews ||
                            []),
                    ],
                })
            );

            setReview("");

            showSuccessAlert({
                title:
                    "Review Published",
            });
        } catch (error) {
            showErrorAlert({
                title:
                    "Unable to publish review",
                text: getBackendError(
                    error,
                    "Please try again."
                ),
            });
        } finally {
            setSavingReview(false);
        }
    };

// const loadSectionClassroom =
//         useCallback(
//             async (
//                 course,
//                 section
//             ) => {
//                 if (
//                     !course?.id ||
//                     !section?.id
//                 ) {
//                     return;
//                 }

//                 try {
//                     setSectionClassroomLoading(
//                         true
//                     );

//                     setSelectedSection(
//                         section
//                     );

//                     setSectionClassroom(
//                         null
//                     );

//                     setActiveSectionEditor(
//                         "overview"
//                     );

//                     const response =
//                         await api.get(
//                             `api/users/subjects/${course.id}/video-sections/${section.id}/classroom/`,
//                             {
//                                 headers,
//                             }
//                         );

//                     const data =
//                         response.data ||
//                         {};

//                     setSectionClassroom(
//                         data
//                     );

//                     setSectionOverview(
//                         data?.overview
//                             ?.content ||
//                             ""
//                     );

//                     setSectionAnnouncementTitle(
//                         ""
//                     );

//                     setSectionAnnouncementContent(
//                         ""
//                     );

//                     setSectionReview("");
//                 } catch (error) {
//                     console.error(
//                         "Section classroom error:",
//                         error
//                     );

//                     showErrorAlert({
//                         title:
//                             "Unable to load video classroom",
//                         text: getBackendError(
//                             error,
//                             "The selected video classroom could not be loaded."
//                         ),
//                     });
//                 } finally {
//                     setSectionClassroomLoading(
//                         false
//                     );
//                 }
//             },
//             [
//                 getBackendError,
//                 headers,
//                 showErrorAlert,
//             ]
//         );


const loadSectionClassroom =
    useCallback(
        async (
            course,
            section
        ) => {
            if (
                !course?.id ||
                !section?.id
            ) {
                return;
            }

            try {
                setSectionClassroomLoading(
                    true
                );

                setSelectedSection(
                    section
                );

                setSectionClassroom(
                    null
                );

                setActiveSectionEditor(
                    "overview"
                );

                const response =
                    await api.get(
                        `api/users/subjects/${course.id}/video-sections/${section.id}/classroom/`,
                        {
                            headers,
                        }
                    );

                const data =
                    response.data ||
                    {};

                setSectionClassroom(
                    data
                );

                setSectionOverview(
                    data?.overview
                        ?.content ||
                        ""
                );

                const announcements =
                    Array.isArray(
                        data?.announcements
                    )
                        ? data.announcements
                        : [];

                const reviews =
                    Array.isArray(
                        data?.reviews
                    )
                        ? data.reviews
                        : [];

                const latestAnnouncement =
                    announcements[0] ||
                    null;

                const latestReview =
                    reviews[0] ||
                    null;

                setAnnouncementTitle(
                    latestAnnouncement?.title ||
                        ""
                );

                setAnnouncementContent(
                    latestAnnouncement?.content ||
                        ""
                );

                setReview(
                    latestReview?.content ||
                        ""
                );
            } catch (error) {
                console.error(
                    "Section classroom error:",
                    error
                );

                showErrorAlert({
                    title:
                        "Unable to load video classroom",
                    text: getBackendError(
                        error,
                        "The selected video classroom could not be loaded."
                    ),
                });
            } finally {
                setSectionClassroomLoading(
                    false
                );
            }
        },
        [
            getBackendError,
            headers,
            showErrorAlert,
        ]
    );

    const resetSectionForm = () => {
        setSectionTitle("");
        setSectionDescription("");
        setSectionVideoFile(null);

        if (
            sectionFileInputRef.current
        ) {
            sectionFileInputRef.current.value =
                "";
        }
    };

    const createVideoSection =
        async () => {
            if (!selectedCourse?.id) {
                return;
            }

            if (!selectedCourse.video) {
                showErrorAlert({
                    title:
                        "Course Introduction Required",
                    text:
                        "Video 1 must be uploaded to the course before you can add another course video.",
                });

                return;
            }

            if (
                !sectionTitle.trim()
            ) {
                showErrorAlert({
                    title:
                        "Video Title Required",
                    text:
                        "Enter a title for this video section.",
                });

                return;
            }

            if (!sectionVideoFile) {
                showErrorAlert({
                    title:
                        "Video File Required",
                    text:
                        "Select a video file to upload.",
                });

                return;
            }

            try {
                setUploadingSection(
                    true
                );

                const formData =
                    new FormData();

                formData.append(
                    "title",
                    sectionTitle.trim()
                );

                formData.append(
                    "description",
                    sectionDescription.trim()
                );

                formData.append(
                    "video",
                    sectionVideoFile
                );

                const response =
                    await api.post(
                        `api/users/subjects/${selectedCourse.id}/video-sections/`,
                        formData,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                const createdSection =
                    response.data;

                setVideoSections(
                    (previous) =>
                        [
                            ...previous,
                            createdSection,
                        ].sort(
                            (a, b) =>
                                getSectionNumber(
                                    a
                                ) -
                                    getSectionNumber(
                                        b
                                    ) ||
                                Number(
                                    a?.id ||
                                        0
                                ) -
                                    Number(
                                        b?.id ||
                                            0
                                    )
                        )
                );

                resetSectionForm();
                setShowSectionUploader(
                    false
                );

                showSuccessAlert({
                    title:
                        `Video ${getSectionNumber(
                            createdSection
                        ) || "Section"} Added`,
                    text:
                        "The course video was uploaded successfully.",
                });
            } catch (error) {
                console.error(
                    "Create video section error:",
                    error
                );

                showErrorAlert({
                    title:
                        "Unable to upload video",
                    text: getBackendError(
                        error,
                        "The video section could not be created."
                    ),
                });
            } finally {
                setUploadingSection(
                    false
                );
            }
        };

    const beginSectionEdit =
        (section) => {
            setEditingSectionId(
                section?.id || null
            );

            setEditingSectionTitle(
                section?.title || ""
            );

            setEditingSectionDescription(
                section?.description || ""
            );

            setEditingSectionVideoFile(
                null
            );

            if (
                editSectionFileInputRef.current
            ) {
                editSectionFileInputRef.current.value =
                    "";
            }
        };

    const cancelSectionEdit =
        () => {
            setEditingSectionId(null);
            setEditingSectionTitle("");
            setEditingSectionDescription(
                ""
            );
            setEditingSectionVideoFile(
                null
            );

            if (
                editSectionFileInputRef.current
            ) {
                editSectionFileInputRef.current.value =
                    "";
            }
        };

    const updateVideoSection =
        async () => {
            if (
                !selectedCourse?.id ||
                !editingSectionId
            ) {
                return;
            }

            if (
                !editingSectionTitle.trim()
            ) {
                showErrorAlert({
                    title:
                        "Video Title Required",
                    text:
                        "Enter a title for this video section.",
                });

                return;
            }

            try {
                setUpdatingSection(
                    true
                );

                const formData =
                    new FormData();

                formData.append(
                    "title",
                    editingSectionTitle.trim()
                );

                formData.append(
                    "description",
                    editingSectionDescription.trim()
                );

                if (
                    editingSectionVideoFile
                ) {
                    formData.append(
                        "video",
                        editingSectionVideoFile
                    );
                }

                const response =
                    await api.patch(
                        `api/users/subjects/${selectedCourse.id}/video-sections/${editingSectionId}/`,
                        formData,
                        {
                            headers: {
                                Authorization: `Bearer ${token}`,
                            },
                        }
                    );

                const updated =
                    response.data;

                setVideoSections(
                    (previous) =>
                        previous.map(
                            (item) =>
                                item.id ===
                                updated.id
                                    ? updated
                                    : item
                        )
                );

                if (
                    selectedSection?.id ===
                    updated.id
                ) {
                    setSelectedSection(
                        updated
                    );
                }

                cancelSectionEdit();

                showSuccessAlert({
                    title:
                        "Video Updated",
                    text:
                        "The video section has been updated successfully.",
                });
            } catch (error) {
                console.error(
                    "Update video section error:",
                    error
                );

                showErrorAlert({
                    title:
                        "Unable to update video",
                    text: getBackendError(
                        error,
                        "The video section could not be updated."
                    ),
                });
            } finally {
                setUpdatingSection(
                    false
                );
            }
        };

    const confirmSectionDelete =
        async (section) => {
            if (
                !section?.id ||
                !selectedCourse?.id
            ) {
                return false;
            }

            const result =
                await Swal.fire({
                    icon: "warning",
                    title:
                        "Delete Video Section?",
                    html: `
                        <div class="cayep-swal-message">
                            <div class="cayep-delete-course-name">
                                Video ${escapeHtml(
                                    getSectionNumber(
                                        section
                                    ) ||
                                        ""
                                )}: ${escapeHtml(
                        section.title ||
                            "Untitled Video"
                    )}
                            </div>

                            <p>
                                This video section will be
                                permanently removed from this
                                course.
                            </p>

                            <div class="cayep-swal-warning-box">
                                <span>⚠</span>
                                <strong>
                                    This action cannot be undone.
                                </strong>
                            </div>
                        </div>
                    `,
                    background: "#07131d",
                    color: "#F0EDEA",
                    iconColor: "#EFA81C",
                    showCancelButton: true,
                    confirmButtonText:
                        "Yes, Delete Video",
                    cancelButtonText:
                        "Keep Video",
                    reverseButtons: true,
                    focusCancel: true,
                    buttonsStyling: false,
                    customClass: {
                        popup:
                            "cayep-swal-popup cayep-swal-delete-popup",
                        title:
                            "cayep-swal-title",
                        htmlContainer:
                            "cayep-swal-html",
                        confirmButton:
                            "cayep-swal-button cayep-swal-button-danger",
                        cancelButton:
                            "cayep-swal-button cayep-swal-button-cancel",
                    },
                });

            return result.isConfirmed;
        };

    const deleteVideoSection =
        async (section) => {
            if (
                !selectedCourse?.id ||
                !section?.id ||
                !canManageSections
            ) {
                return;
            }

            const confirmed =
                await confirmSectionDelete(
                    section
                );

            if (!confirmed) {
                return;
            }

            try {
                setDeletingSection(true);

                await api.delete(
                    `api/users/subjects/${selectedCourse.id}/video-sections/${section.id}/`,
                    {
                        headers,
                    }
                );

                const deletedId =
                    section.id;

                setVideoSections(
                    (previous) =>
                        previous.filter(
                            (item) =>
                                item.id !==
                                deletedId
                        )
                );

                if (
                    selectedSection?.id ===
                    deletedId
                ) {
                    setSelectedSection(
                        null
                    );
                    setSectionClassroom(
                        null
                    );
                }

                showSuccessAlert({
                    title:
                        "Video Deleted",
                    text:
                        "The course video section was removed successfully.",
                });
            } catch (error) {
                console.error(
                    "Delete video section error:",
                    error
                );

                showErrorAlert({
                    title:
                        "Unable to delete video",
                    text: getBackendError(
                        error,
                        "The video section could not be deleted."
                    ),
                });
            } finally {
                setDeletingSection(
                    false
                );
            }
        };

    const saveSectionOverview =
        async () => {
            if (
                !selectedCourse?.id ||
                !selectedSection?.id ||
                !sectionOverview.trim()
            ) {
                return;
            }

            try {
                setSavingSectionOverview(
                    true
                );

                const response =
                    await api.post(
                        `api/users/subjects/${selectedCourse.id}/video-sections/${selectedSection.id}/overview/`,
                        {
                            content:
                                sectionOverview.trim(),
                        },
                        {
                            headers,
                        }
                    );

                setSectionClassroom(
                    (previous) => ({
                        ...previous,
                        overview:
                            response.data,
                    })
                );

                showSuccessAlert({
                    title:
                        "Video Overview Published",
                });
            } catch (error) {
                showErrorAlert({
                    title:
                        "Unable to save video overview",
                    text: getBackendError(
                        error,
                        "Please try again."
                    ),
                });
            } finally {
                setSavingSectionOverview(
                    false
                );
            }
        };

    const publishSectionAnnouncement =
        async () => {
            if (
                !selectedCourse?.id ||
                !selectedSection?.id ||
                !sectionAnnouncementTitle.trim() ||
                !sectionAnnouncementContent.trim()
            ) {
                return;
            }

            try {
                setSavingSectionAnnouncement(
                    true
                );

                const response =
                    await api.post(
                        `api/users/subjects/${selectedCourse.id}/video-sections/${selectedSection.id}/announcements/`,
                        {
                            title:
                                sectionAnnouncementTitle.trim(),
                            content:
                                sectionAnnouncementContent.trim(),
                        },
                        {
                            headers,
                        }
                    );

                setSectionClassroom(
                    (previous) => ({
                        ...previous,
                        announcements: [
                            response.data,
                            ...(previous
                                ?.announcements ||
                                []),
                        ],
                    })
                );

                setSectionAnnouncementTitle(
                    ""
                );

                setSectionAnnouncementContent(
                    ""
                );

                showSuccessAlert({
                    title:
                        "Video Announcement Published",
                });
            } catch (error) {
                showErrorAlert({
                    title:
                        "Unable to publish announcement",
                    text: getBackendError(
                        error,
                        "Please try again."
                    ),
                });
            } finally {
                setSavingSectionAnnouncement(
                    false
                );
            }
        };

    const publishSectionReview =
        async () => {
            if (
                !selectedCourse?.id ||
                !selectedSection?.id ||
                !sectionReview.trim()
            ) {
                return;
            }

            try {
                setSavingSectionReview(
                    true
                );

                const response =
                    await api.post(
                        `api/users/subjects/${selectedCourse.id}/video-sections/${selectedSection.id}/reviews/`,
                        {
                            content:
                                sectionReview.trim(),
                        },
                        {
                            headers,
                        }
                    );

                setSectionClassroom(
                    (previous) => ({
                        ...previous,
                        reviews: [
                            response.data,
                            ...(previous
                                ?.reviews ||
                                []),
                        ],
                    })
                );

                setSectionReview("");

                showSuccessAlert({
                    title:
                        "Video Review Published",
                });
            } catch (error) {
                showErrorAlert({
                    title:
                        "Unable to publish video review",
                    text: getBackendError(
                        error,
                        "Please try again."
                    ),
                });
            } finally {
                setSavingSectionReview(
                    false
                );
            }
        };

    const handleEditCourse =
        (course) => {
            if (!course) {
                return;
            }

            if (!canEditCourses) {
                showErrorAlert({
                    title:
                        "Edit Permission Required",
                    text:
                        "Your account does not have permission to edit courses.",
                });

                return;
            }

            setEditCourse(course);
        };

    const handleCourseUpdated =
        (updatedCourse) => {
            if (!updatedCourse?.id) {
                return;
            }

            setCourses(
                (previous) =>
                    previous.map(
                        (course) =>
                            course.id ===
                            updatedCourse.id
                                ? updatedCourse
                                : course
                    )
            );

            if (
                selectedCourse?.id ===
                updatedCourse.id
            ) {
                setSelectedCourse(
                    updatedCourse
                );

                loadVideoSections(
                    updatedCourse.id
                );
            }

            setEditCourse(null);

            showSuccessAlert({
                title:
                    "Course Updated",
                text:
                    "The course has been updated successfully.",
            });
        };

    const handleCourseDeleted =
        async (
            deletedId,
            showAlert = false
        ) => {
            const wasSelected =
                selectedCourse?.id ===
                deletedId;

            if (wasSelected) {
                setSelectedCourse(null);
                setClassroom(null);
                setVideoSections([]);
                setSelectedSection(null);
                setSectionClassroom(null);
                setOverview("");
                setAnnouncementTitle("");
                setAnnouncementContent("");
                setReview("");
                setActiveEditor(
                    "overview"
                );
            }

            setEditCourse(null);

            const remainingOnPage =
                courses.length - 1;

            if (
                remainingOnPage === 0 &&
                page > 1
            ) {
                const previousPage =
                    page - 1;

                setPage(previousPage);

                await loadCourses(
                    previousPage,
                    searchTerm
                );
            } else {
                await loadCourses(
                    page,
                    searchTerm
                );
            }

            if (showAlert) {
                showSuccessAlert({
                    title:
                        "Course Deleted",
                    text:
                        "The course was removed successfully.",
                });
            }
        };

    const handleDeleteCourse =
        async (course) => {
            if (!course?.id) {
                return;
            }

            if (!canDeleteCourses) {
                showTeacherDeleteDeniedAlert();
                return;
            }

            if (deletingCourse) {
                return;
            }

            const confirmed =
                await confirmCourseDelete(
                    course
                );

            if (!confirmed) {
                return;
            }

            try {
                setDeletingCourse(true);

                await api.delete(
                    `api/users/subjects/${course.id}/`,
                    {
                        headers,
                    }
                );

                await handleCourseDeleted(
                    course.id,
                    false
                );

                const courseName =
                    course.name ||
                    course.title ||
                    course.subject_name ||
                    "Course";

                await Swal.fire({
                    icon: "success",
                    title:
                        "Course Deleted",
                    html: `
                        <div class="cayep-swal-message">
                            <div class="cayep-delete-success-icon">
                                ✓
                            </div>

                            <p>
                                <strong>
                                    ${escapeHtml(
                                        courseName
                                    )}
                                </strong>
                                has been permanently deleted.
                            </p>
                        </div>
                    `,
                    background: "#07131d",
                    color: "#F0EDEA",
                    iconColor: "#8FD06E",
                    confirmButtonText:
                        "Done",
                    buttonsStyling: false,
                    customClass: {
                        popup:
                            "cayep-swal-popup",
                        title:
                            "cayep-swal-title",
                        htmlContainer:
                            "cayep-swal-html",
                        confirmButton:
                            "cayep-swal-button cayep-swal-button-success",
                    },
                });
            } catch (error) {
                console.error(
                    "Delete course error:",
                    error
                );

                let errorMessage =
                    getBackendError(
                        error,
                        "The course could not be deleted."
                    );

                if (
                    error.response?.status ===
                    403
                ) {
                    errorMessage =
                        "You do not have permission to delete this course. Please contact an Admin or Principal.";
                }

                if (
                    error.response?.status ===
                    404
                ) {
                    errorMessage =
                        "This course could not be found. It may have already been deleted.";
                }

                await Swal.fire({
                    icon: "error",
                    title:
                        "Delete Failed",
                    html: `
                        <div class="cayep-swal-message">
                            <p>
                                ${escapeHtml(
                                    errorMessage
                                )}
                            </p>
                        </div>
                    `,
                    background: "#07131d",
                    color: "#F0EDEA",
                    iconColor: "#E57373",
                    confirmButtonText:
                        "Close",
                    buttonsStyling: false,
                    customClass: {
                        popup:
                            "cayep-swal-popup",
                        title:
                            "cayep-swal-title",
                        htmlContainer:
                            "cayep-swal-html",
                        confirmButton:
                            "cayep-swal-button cayep-swal-button-danger",
                    },
                });
            } finally {
                setDeletingCourse(
                    false
                );
            }
        };

    const handleDeleteDenied =
        () => {
            showTeacherDeleteDeniedAlert();
        };

    const renderPagination = () => {
        if (
            totalCourses <= pageSize
        ) {
            return null;
        }

        const pages = [];

        const start = Math.max(
            1,
            page - 2
        );

        const end = Math.min(
            totalPages,
            page + 2
        );

        for (
            let index = start;
            index <= end;
            index += 1
        ) {
            pages.push(index);
        }

        return (
            <div className="cayep-course-pagination">
                <button
                    type="button"
                    disabled={
                        page === 1
                    }
                    onClick={() =>
                        handlePageChange(
                            page - 1
                        )
                    }
                >
                    <FaChevronLeft />
                    Previous
                </button>

                {start > 1 && (
                    <>
                        <button
                            type="button"
                            onClick={() =>
                                handlePageChange(
                                    1
                                )
                            }
                        >
                            1
                        </button>

                        {start > 2 && (
                            <span>
                                ...
                            </span>
                        )}
                    </>
                )}

                {pages.map(
                    (pageNumber) => (
                        <button
                            type="button"
                            key={
                                pageNumber
                            }
                            className={
                                pageNumber ===
                                page
                                    ? "active"
                                    : ""
                            }
                            onClick={() =>
                                handlePageChange(
                                    pageNumber
                                )
                            }
                        >
                            {
                                pageNumber
                            }
                        </button>
                    )
                )}

                {end <
                    totalPages && (
                    <>
                        {end <
                            totalPages -
                                1 && (
                            <span>
                                ...
                            </span>
                        )}

                        <button
                            type="button"
                            onClick={() =>
                                handlePageChange(
                                    totalPages
                                )
                            }
                        >
                            {
                                totalPages
                            }
                        </button>
                    </>
                )}

                <button
                    type="button"
                    disabled={
                        page ===
                        totalPages
                    }
                    onClick={() =>
                        handlePageChange(
                            page + 1
                        )
                    }
                >
                    Next
                    <FaChevronRight />
                </button>
            </div>
        );
    };

    const mainVideoDuration =
        Number(
            selectedCourse?.video_duration_seconds
        ) || 0;

    const totalVideoCount =
        getCourseVideoCount(
            selectedCourse,
            videoSections
        );

    const totalDuration =
        getCourseTotalDuration(
            selectedCourse,
            videoSections
        );

    const selectedSectionDuration =
        normalizeDurationSeconds(
            selectedSection
        );

    return (
        <div className="cayep-view-courses">
            <div className="cayep-view-header">
                <div>
                    <span>
                        CAYEP LEADERSHIP TRAINING
                    </span>

                    <h1>
                        {isTeacher
                            ? "My Courses"
                            : "All Courses"}
                    </h1>

                    <p>
                        Manage courses, videos,
                        classroom content, and
                        section-by-section learning
                        experiences.
                    </p>
                </div>

                <div className="cayep-course-count">
                    <FaLayerGroup />

                    <strong>
                        {totalCourses}
                    </strong>

                    <span>
                        Courses
                    </span>
                </div>
            </div>

            <div className="cayep-course-toolbar">
                <div className="cayep-course-search">
                    <FaSearch />

                    <input
                        type="search"
                        value={searchTerm}
                        onChange={(
                            event
                        ) =>
                            setSearchTerm(
                                event
                                    .target
                                    .value
                            )
                        }
                        placeholder="Search courses by name..."
                        aria-label="Search courses"
                    />

                    {searchTerm && (
                        <button
                            type="button"
                            onClick={() =>
                                setSearchTerm(
                                    ""
                                )
                            }
                            aria-label="Clear course search"
                        >
                            ×
                        </button>
                    )}
                </div>

                <div className="cayep-course-toolbar-info">
                    {loading
                        ? "Loading..."
                        : totalCourses ===
                          0
                        ? "No courses found"
                        : `Showing ${
                              (page -
                                  1) *
                                  pageSize +
                              1
                          }–${Math.min(
                              page *
                                  pageSize,
                              totalCourses
                          )} of ${totalCourses}`}
                </div>
            </div>

            {loading ? (
                <div className="cayep-view-state">
                    <FaBookOpen />

                    <h3>
                        Loading Courses
                    </h3>

                    <p>
                        Please wait while
                        your courses are
                        being loaded.
                    </p>
                </div>
            ) : courses.length ===
              0 ? (
                <div className="cayep-view-state">
                    <FaBookOpen />

                    <h3>
                        {searchTerm
                            ? "No Matching Courses"
                            : "No Courses Yet"}
                    </h3>

                    <p>
                        {searchTerm
                            ? "Try another course name or clear the search."
                            : isTeacher
                            ? "Courses you create or are assigned to will appear here."
                            : "Courses available to your account will appear here."}
                    </p>

                    {searchTerm && (
                        <button
                            type="button"
                            onClick={() =>
                                setSearchTerm(
                                    ""
                                )
                            }
                        >
                            Clear Search
                        </button>
                    )}
                </div>
            ) : (
                <>
                    <div className="cayep-teacher-course-layout">
                        <div className="cayep-teacher-course-sidebar">
                            <div className="cayep-course-list-heading">
                                <div>
                                    <strong>
                                        Course Library
                                    </strong>

                                    <small>
                                        {isTeacher
                                            ? "Courses created or assigned to you"
                                            : "All available courses"}
                                    </small>
                                </div>
                            </div>

                            <div className="cayep-teacher-course-list">
                                {courses.map(
                                    (
                                        course
                                    ) => (
                                        <div
                                            className={
                                                selectedCourse?.id ===
                                                course.id
                                                    ? "cayep-course-item active"
                                                    : "cayep-course-item"
                                            }
                                            key={
                                                course.id
                                            }
                                        >
                                            <button
                                                type="button"
                                                className="cayep-course-select"
                                                onClick={() =>
                                                    loadClassroom(
                                                        course
                                                    )
                                                }
                                            >
                                                <div className="cayep-teacher-course-image">
                                                    {course.image ? (
                                                        <img
                                                            src={getMediaUrl(
                                                                course.image
                                                            )}
                                                            alt={
                                                                course.name
                                                            }
                                                        />
                                                    ) : (
                                                        <FaBookOpen />
                                                    )}

                                                    {course.video && (
                                                        <span>
                                                            <FaPlay />
                                                        </span>
                                                    )}
                                                </div>

                                                <div className="cayep-teacher-course-info">
                                                    <strong>
                                                        {
                                                            course.name
                                                        }
                                                    </strong>

                                                    <small>
                                                        {course.category ||
                                                            "Course"}
                                                    </small>

                                                    <div>
                                                        {course.duration && (
                                                            <span>
                                                                <FaClock />
                                                                {
                                                                    course.duration
                                                                }
                                                            </span>
                                                        )}

                                                        {course.lessons && (
                                                            <span>
                                                                <FaBookOpen />
                                                                {
                                                                    course.lessons
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </button>

                                            {canEditCourses && (
                                                <div className="cayep-course-item-actions">
                                                    <button
                                                        type="button"
                                                        className="cayep-course-edit-button"
                                                        onClick={() =>
                                                            handleEditCourse(
                                                                course
                                                            )
                                                        }
                                                        title="Edit course"
                                                        aria-label={`Edit ${course.name}`}
                                                    >
                                                        <FaEdit />
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className={
                                                            canDeleteCourses
                                                                ? "cayep-course-delete-button"
                                                                : "cayep-course-delete-button restricted"
                                                        }
                                                        onClick={() =>
                                                            handleDeleteCourse(
                                                                course
                                                            )
                                                        }
                                                        title={
                                                            canDeleteCourses
                                                                ? "Delete course"
                                                                : "Delete permission required"
                                                        }
                                                        aria-label={`Delete ${course.name}`}
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )
                                )}
                            </div>
                        </div>

                        <div className="cayep-teacher-course-workspace">
                            {!selectedCourse ? (
                                <div className="cayep-workspace-empty">
                                    <FaGraduationCap />

                                    <h3>
                                        Select a
                                        Course
                                    </h3>

                                    <p>
                                        Select a
                                        course to
                                        manage its
                                        videos and
                                        classroom
                                        learning
                                        environment.
                                    </p>
                                </div>
                            ) : classroomLoading ? (
                                <div className="cayep-workspace-empty">
                                    <FaBookOpen />

                                    <h3>
                                        Loading
                                        Classroom
                                    </h3>

                                    <p>
                                        Please
                                        wait
                                        while the
                                        selected
                                        course
                                        is loaded.
                                    </p>
                                </div>
                            ) : (
                                <>
                                    <div className="cayep-workspace-header">
                                        <div>
                                            <span>
                                                COURSE CLASSROOM
                                            </span>

                                            <h2>
                                                {
                                                    selectedCourse.name
                                                }
                                            </h2>

                                            <div className="cayep-course-stat-row">
                                                <span>
                                                    <FaVideo />
                                                    {
                                                        totalVideoCount
                                                    }{" "}
                                                    {totalVideoCount ===
                                                    1
                                                        ? "Video"
                                                        : "Videos"}
                                                </span>

                                                <span>
                                                    <FaClock />
                                                    {formatDuration(
                                                        totalDuration
                                                    )}
                                                </span>

                                                {selectedCourse.level && (
                                                    <span>
                                                        <FaGraduationCap />
                                                        {
                                                            selectedCourse.level
                                                        }
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div className="cayep-workspace-actions">
                                            {selectedCourse.video ? (
                                                <div className="cayep-video-badge">
                                                    <FaCheckCircle />
                                                    Video 1
                                                    Published
                                                </div>
                                            ) : (
                                                <div className="cayep-video-badge warning">
                                                    <FaExclamationTriangle />
                                                    Video 1
                                                    Required
                                                </div>
                                            )}

                                            {canEditCourses && (
                                                <button
                                                    type="button"
                                                    className="cayep-workspace-edit"
                                                    onClick={() =>
                                                        handleEditCourse(
                                                            selectedCourse
                                                        )
                                                    }
                                                >
                                                    <FaEdit />
                                                    Edit Course
                                                </button>
                                            )}

                                            {canDeleteCourses && (
                                                <button
                                                    type="button"
                                                    className="cayep-workspace-delete"
                                                    disabled={
                                                        deletingCourse
                                                    }
                                                    onClick={() =>
                                                        handleDeleteCourse(
                                                            selectedCourse
                                                        )
                                                    }
                                                >
                                                    <FaTrash />
                                                    {deletingCourse
                                                        ? "Deleting..."
                                                        : "Delete Course"}
                                                </button>
                                            )}

                                            {!canDeleteCourses &&
                                                isTeacher && (
                                                    <div className="cayep-teacher-permission-badge">
                                                        <FaEdit />
                                                        Edit
                                                        access
                                                        only
                                                    </div>
                                                )}
                                        </div>
                                    </div>

                                    {selectedCourse.image && (
                                        <div className="cayep-teacher-preview">
                                            <img
                                                src={getMediaUrl(
                                                    selectedCourse.image
                                                )}
                                                alt={
                                                    selectedCourse.name
                                                }
                                            />

                                            <div>
                                                <div className="cayep-preview-kicker">
                                                    COURSE
                                                    OVERVIEW
                                                </div>

                                                <h3>
                                                    {
                                                        selectedCourse.name
                                                    }
                                                </h3>

                                                <p>
                                                    {
                                                        selectedCourse.description
                                                    }
                                                </p>

                                                <div className="cayep-preview-stats">
                                                    <span>
                                                        <FaVideo />
                                                        {
                                                            totalVideoCount
                                                        }{" "}
                                                        videos
                                                    </span>

                                                    <span>
                                                        <FaClock />
                                                        {formatDuration(
                                                            totalDuration
                                                        )}
                                                    </span>

                                                    {mainVideoDuration >
                                                        0 && (
                                                        <span>
                                                            <FaPlay />
                                                            Video
                                                            1:
                                                            {" "}
                                                            {formatDuration(
                                                                mainVideoDuration
                                                            )}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

<div className="cayep-course-video-library">
    <div className="cayep-video-library-header">
        <div>
            <span>VIDEO LIBRARY</span>

            <h3>
                Course
                Videos
            </h3>

            <p>
                Video 1 is the course introduction.
                Additional videos belong exclusively
                to this course.
            </p>
        </div>

        {canManageSections && (
            <button
                type="button"
                className="cayep-add-video-button"
                disabled={!selectedCourse.video}
                onClick={() =>
                    setShowSectionUploader(
                        (previous) => !previous
                    )
                }
            >
                <FaPlus />
                Add Course Video
            </button>
        )}
    </div>

    {!selectedCourse.video && (
        <div className="cayep-video-required-notice">
            <FaExclamationTriangle />

            <div>
                <strong>
                    Upload Video 1 before adding more
                    videos.
                </strong>

                <p>
                    The backend requires the main
                    course introduction video to exist
                    before Video 2 and later sections
                    can be created.
                </p>
            </div>
        </div>
    )}

    {showSectionUploader && canManageSections && (
        <div className="cayep-video-upload-panel">
            <div className="cayep-section-panel-title">
                <div className="cayep-section-number-badge">
                    <FaUpload />
                </div>

                <div>
                    <h4>
                        Add Course Video
                    </h4>

                    <p>
                        The backend will automatically
                        assign the next video number and
                        calculate the actual video duration.
                    </p>
                </div>

                <button
                    type="button"
                    onClick={() => {
                        resetSectionForm();
                        setShowSectionUploader(false);
                    }}
                    aria-label="Close video upload form"
                >
                    <FaTimes />
                </button>
            </div>

            <div className="cayep-section-form-grid">
                <div className="cayep-form-field">
                    <label>
                        Video Title
                    </label>

                    <input
                        type="text"
                        value={sectionTitle}
                        onChange={(event) =>
                            setSectionTitle(
                                event.target.value
                            )
                        }
                        maxLength={200}
                        placeholder="e.g. Leadership Principles"
                    />
                </div>

                <div className="cayep-form-field">
                    <label>
                        Video File
                    </label>

                    <input
                        ref={sectionFileInputRef}
                        type="file"
                        accept="video/*"
                        onChange={(event) =>
                            setSectionVideoFile(
                                event.target.files?.[0] ||
                                    null
                            )
                        }
                    />

                    {sectionVideoFile && (
                        <small className="cayep-selected-file">
                            <FaCheckCircle />
                            {sectionVideoFile.name}
                        </small>
                    )}
                </div>
            </div>

            <div className="cayep-form-field">
                <label>
                    Description
                </label>

                <textarea
                    value={sectionDescription}
                    onChange={(event) =>
                        setSectionDescription(
                            event.target.value
                        )
                    }
                    rows={5}
                    placeholder="Describe what learners will study in this video..."
                />
            </div>

            <div className="cayep-section-form-actions">
                <button
                    type="button"
                    className="cayep-secondary-action"
                    onClick={() => {
                        resetSectionForm();
                        setShowSectionUploader(false);
                    }}
                    disabled={uploadingSection}
                >
                    Cancel
                </button>

                <button
                    type="button"
                    className="cayep-primary-action"
                    onClick={createVideoSection}
                    disabled={
                        uploadingSection ||
                        !sectionTitle.trim() ||
                        !sectionVideoFile
                    }
                >
                    <FaUpload />

                    {uploadingSection
                        ? "Uploading..."
                        : "Upload Video"}
                </button>
            </div>
        </div>
    )}

    <div className="cayep-course-video-list">
        {selectedCourse.video && (
            <div
                className={
                    !selectedSection
                        ? "cayep-video-card main-video selected"
                        : "cayep-video-card main-video"
                }
            >
                <button
                    type="button"
                    className="cayep-video-card-main"
                    onClick={() => {
                        setSelectedSection(null);
                        setSectionClassroom(null);
                    }}
                >
                    <div className="cayep-video-number main">
                        1
                    </div>

                    <div className="cayep-video-thumbnail">
                        {selectedCourse.image ? (
                            <img
                                src={getMediaUrl(
                                    selectedCourse.image
                                )}
                                alt={
                                    selectedCourse.name
                                }
                            />
                        ) : (
                            <FaVideo />
                        )}

                        <span>
                            <FaPlay />
                        </span>
                    </div>

                    <div className="cayep-video-card-content">
                        <div className="cayep-video-card-kicker">
                            COURSE INTRODUCTION
                        </div>

                        <h4>
                            {selectedCourse.name}
                        </h4>

                        <p>
                            {selectedCourse.description ||
                                "Course introduction video"}
                        </p>

                        <div className="cayep-video-card-meta">
                            <span>
                                <FaClock />

                                {mainVideoDuration > 0
                                    ? formatDuration(
                                          mainVideoDuration
                                      )
                                    : "Duration unavailable"}
                            </span>

                            <span className="published">
                                <FaCheckCircle />
                                Published
                            </span>
                        </div>
                    </div>
                </button>

                {mainVideoDuration > 0 && (
                    <div className="cayep-video-duration-bar">
                        Actual video duration:{" "}
                        {formatDuration(
                            mainVideoDuration
                        )}
                    </div>
                )}
            </div>
        )}

        {sectionsLoading ? (
            <div className="cayep-video-list-loading">
                <FaVideo />

                <span>
                    Loading course videos...
                </span>
            </div>
        ) : videoSections.length > 0 ? (
            videoSections.map((section) => {
                const sectionNumber =
                    getSectionNumber(section);

                const duration =
                    normalizeDurationSeconds(
                        section
                    );

                const isSelected =
                    selectedSection?.id ===
                    section.id;

                const mediaUrl =
                    getMediaUrl(section.video);

                return (
                    <div
                        className={
                            isSelected
                                ? "cayep-video-card selected"
                                : "cayep-video-card"
                        }
                        key={section.id}
                    >
                        {editingSectionId ===
                        section.id ? (
                            <div className="cayep-section-edit-panel">
                                <div className="cayep-section-edit-header">
                                    <strong>
                                        Edit Video{" "}
                                        {sectionNumber}
                                    </strong>

                                    <button
                                        type="button"
                                        onClick={
                                            cancelSectionEdit
                                        }
                                        aria-label="Cancel video editing"
                                    >
                                        <FaTimes />
                                    </button>
                                </div>

                                <input
                                    type="text"
                                    value={
                                        editingSectionTitle
                                    }
                                    onChange={(event) =>
                                        setEditingSectionTitle(
                                            event.target.value
                                        )
                                    }
                                    maxLength={200}
                                />

                                <textarea
                                    value={
                                        editingSectionDescription
                                    }
                                    onChange={(event) =>
                                        setEditingSectionDescription(
                                            event.target.value
                                        )
                                    }
                                    rows={4}
                                />

                                <input
                                    ref={
                                        editSectionFileInputRef
                                    }
                                    type="file"
                                    accept="video/*"
                                    onChange={(event) =>
                                        setEditingSectionVideoFile(
                                            event.target
                                                .files?.[0] ||
                                                null
                                        )
                                    }
                                />

                                {editingSectionVideoFile && (
                                    <small className="cayep-selected-file">
                                        <FaCheckCircle />

                                        {
                                            editingSectionVideoFile.name
                                        }
                                    </small>
                                )}

                                <div className="cayep-section-edit-actions">
                                    <button
                                        type="button"
                                        className="cayep-secondary-action"
                                        onClick={
                                            cancelSectionEdit
                                        }
                                        disabled={
                                            updatingSection
                                        }
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        className="cayep-primary-action"
                                        onClick={
                                            updateVideoSection
                                        }
                                        disabled={
                                            updatingSection ||
                                            !editingSectionTitle.trim()
                                        }
                                    >
                                        <FaSave />

                                        {updatingSection
                                            ? "Saving..."
                                            : "Save Changes"}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <>
                                <button
                                    type="button"
                                    className="cayep-video-card-main"
                                    onClick={() =>
                                        loadSectionClassroom(
                                            selectedCourse,
                                            section
                                        )
                                    }
                                >
                                    <div className="cayep-video-number">
                                        {sectionNumber}
                                    </div>

                                    <div className="cayep-video-thumbnail">
                                        {selectedCourse.image ? (
                                            <img
                                                src={getMediaUrl(
                                                    selectedCourse.image
                                                )}
                                                alt={
                                                    section.title
                                                }
                                            />
                                        ) : (
                                            <FaVideo />
                                        )}

                                        <span>
                                            <FaPlay />
                                        </span>
                                    </div>

                                    <div className="cayep-video-card-content">
                                        <div className="cayep-video-card-kicker">
                                            VIDEO{" "}
                                            {sectionNumber}
                                        </div>

                                        <h4>
                                            {
                                                section.title
                                            }
                                        </h4>

                                        <p>
                                            {section.description ||
                                                "No description provided for this video."}
                                        </p>

                                        <div className="cayep-video-card-meta">
                                            <span>
                                                <FaClock />

                                                {duration >
                                                0
                                                    ? formatDuration(
                                                          duration
                                                      )
                                                    : "Duration unavailable"}
                                            </span>

                                            <span className="published">
                                                <FaCheckCircle />
                                                Published
                                            </span>
                                        </div>
                                    </div>
                                </button>

                                <div
                                    className="cayep-video-resources"
                                    onClick={(event) =>
                                        event.stopPropagation()
                                    }
                                >
                                    <div className="cayep-video-resources-header">
                                        <div>
                                            <span className="cayep-resource-kicker">
                                                LEARNING
                                                MATERIALS
                                            </span>

                                            <h5>
                                                <FaPaperclip />
                                                Video Resources
                                            </h5>
                                        </div>

                                        {canManageSections && (
                                            <button
                                                type="button"
                                                className="cayep-resource-toggle"
                                                onClick={() => {
                                                    const nextId =
                                                        openResourceSectionId ===
                                                        section.id
                                                            ? null
                                                            : section.id;

                                                    setOpenResourceSectionId(
                                                        nextId
                                                    );

                                                    if (
                                                        nextId ===
                                                            section.id &&
                                                        !sectionResources[
                                                            section.id
                                                        ]
                                                    ) {
                                                        fetchSectionResources(
                                                            section
                                                        );
                                                    }
                                                }}
                                            >
                                                <FaUpload />

                                                {openResourceSectionId ===
                                                section.id
                                                    ? "Close"
                                                    : "Add Resource"}
                                            </button>
                                        )}
                                    </div>

                                    {openResourceSectionId ===
                                        section.id && (
                                        <div className="cayep-video-resource-upload">
                                            <div className="cayep-resource-form-grid">
                                                <div className="cayep-form-field">
                                                    <label>
                                                        Resource
                                                        Title
                                                    </label>

                                                    <input
                                                        type="text"
                                                        value={
                                                            sectionResourceTitles[
                                                                section.id
                                                            ] ||
                                                            ""
                                                        }
                                                        onChange={(
                                                            event
                                                        ) => {
                                                            setSectionResourceTitles(
                                                                (
                                                                    previous
                                                                ) => ({
                                                                    ...previous,
                                                                    [section.id]:
                                                                        event
                                                                            .target
                                                                            .value,
                                                                })
                                                            );
                                                        }}
                                                        maxLength={
                                                            200
                                                        }
                                                        placeholder="e.g. Leadership Principles Notes"
                                                    />
                                                </div>

                                                <div className="cayep-form-field">
                                                    <label>
                                                        Resource
                                                        File
                                                    </label>

                                                    <input
                                                        type="file"
                                                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt"
                                                        onChange={(
                                                            event
                                                        ) => {
                                                            const file =
                                                                event
                                                                    .target
                                                                    .files?.[0] ||
                                                                null;

                                                            if (
                                                                !file
                                                            ) {
                                                                return;
                                                            }

                                                            const extension =
                                                                getResourceExtension(
                                                                    file.name
                                                                );

                                                            if (
                                                                !RESOURCE_EXTENSIONS.includes(
                                                                    extension
                                                                )
                                                            ) {
                                                                showCayepAlert(
                                                                    {
                                                                        type: "warning",
                                                                        title: "Unsupported File",
                                                                        text: "Allowed files are PDF, Word, Excel, PowerPoint, CSV and TXT.",
                                                                    }
                                                                );

                                                                event.target.value =
                                                                    "";
                                                                return;
                                                            }

                                                            if (
                                                                file.size >
                                                                RESOURCE_MAX_SIZE
                                                            ) {
                                                                showCayepAlert(
                                                                    {
                                                                        type: "warning",
                                                                        title: "File Too Large",
                                                                        text: "Learning resources cannot be larger than 50 MB.",
                                                                    }
                                                                );

                                                                event.target.value =
                                                                    "";
                                                                return;
                                                            }

                                                            setSectionResourceFiles(
                                                                (
                                                                    previous
                                                                ) => ({
                                                                    ...previous,
                                                                    [section.id]:
                                                                        file,
                                                                })
                                                            );

                                                            if (
                                                                !String(
                                                                    sectionResourceTitles[
                                                                        section.id
                                                                    ] ||
                                                                        ""
                                                                ).trim()
                                                            ) {
                                                                setSectionResourceTitles(
                                                                    (
                                                                        previous
                                                                    ) => ({
                                                                        ...previous,
                                                                        [section.id]:
                                                                            file.name.replace(
                                                                                /\.[^/.]+$/,
                                                                                ""
                                                                            ),
                                                                    })
                                                                );
                                                            }
                                                        }}
                                                    />

                                                    {sectionResourceFiles[
                                                        section.id
                                                    ] && (
                                                        <div className="cayep-selected-resource-file">
                                                            <FaPaperclip />

                                                            <div>
                                                                <strong>
                                                                    {
                                                                        sectionResourceFiles[
                                                                            section.id
                                                                        ]
                                                                            .name
                                                                    }
                                                                </strong>

                                                                <span>
                                                                    {(
                                                                        sectionResourceFiles[
                                                                            section.id
                                                                        ]
                                                                            .size /
                                                                        1024 /
                                                                        1024
                                                                    ).toFixed(
                                                                        2
                                                                    )}{" "}
                                                                    MB
                                                                </span>
                                                            </div>

                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setSectionResourceFiles(
                                                                        (
                                                                            previous
                                                                        ) => ({
                                                                            ...previous,
                                                                            [section.id]:
                                                                                null,
                                                                        })
                                                                    );
                                                                }}
                                                            >
                                                                <FaTimes />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="cayep-form-field">
                                                <label>
                                                    Resource
                                                    Description
                                                </label>

                                                <textarea
                                                    value={
                                                        sectionResourceDescriptions[
                                                            section.id
                                                        ] ||
                                                        ""
                                                    }
                                                    onChange={(
                                                        event
                                                    ) => {
                                                        setSectionResourceDescriptions(
                                                            (
                                                                previous
                                                            ) => ({
                                                                ...previous,
                                                                [section.id]:
                                                                    event
                                                                        .target
                                                                        .value,
                                                            })
                                                        );
                                                    }}
                                                    rows={3}
                                                    placeholder="Describe this learning material..."
                                                />
                                            </div>

                                            <div className="cayep-resource-form-actions">
                                                <button
                                                    type="button"
                                                    className="cayep-secondary-action"
                                                    onClick={() => {
                                                        setOpenResourceSectionId(
                                                            null
                                                        );
                                                    }}
                                                    disabled={
                                                        sectionResourceUploading[
                                                            section
                                                                .id
                                                        ]
                                                    }
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    type="button"
                                                    className="cayep-primary-action"
                                                    onClick={() =>
                                                        uploadSectionResource(
                                                            section
                                                        )
                                                    }
                                                    disabled={
                                                        sectionResourceUploading[
                                                            section
                                                                .id
                                                        ] ||
                                                        !sectionResourceFiles[
                                                            section
                                                                .id
                                                        ]
                                                    }
                                                >
                                                    <FaUpload />

                                                    {sectionResourceUploading[
                                                        section.id
                                                    ]
                                                        ? "Uploading..."
                                                        : "Upload Resource"}
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    <div className="cayep-video-resource-list">
                                        {sectionResourcesLoading[
                                            section.id
                                        ] ? (
                                            <div className="cayep-resource-loading">
                                                Loading resources...
                                            </div>
                                        ) : (
                                            <>
                                                {(
                                                    sectionResources[
                                                        section.id
                                                    ] || []
                                                ).map(
                                                    (
                                                        resource
                                                    ) => (
                                                        <div
                                                            className="cayep-resource-item"
                                                            key={
                                                                resource.id
                                                            }
                                                        >
                                                            <div className="cayep-resource-icon">
                                                                <FaPaperclip />
                                                            </div>

                                                            <div className="cayep-resource-info">
                                                                <strong>
                                                                    {resource.title ||
                                                                        getResourceName(
                                                                            resource
                                                                        )}
                                                                </strong>

                                                                <span>
                                                                    {getResourceName(
                                                                        resource
                                                                    )}
                                                                </span>

                                                                {resource.description && (
                                                                    <small>
                                                                        {
                                                                            resource.description
                                                                        }
                                                                    </small>
                                                                )}
                                                            </div>

                                                            <div className="cayep-resource-actions">
                                                                <button
                                                                    type="button"
                                                                    title="Open resource"
                                                                    onClick={() => {
                                                                        const url =
                                                                            resolveResourceUrl(
                                                                                getResourceUrl(
                                                                                    resource
                                                                                )
                                                                            );

                                                                        if (
                                                                            url
                                                                        ) {
                                                                            window.open(
                                                                                url,
                                                                                "_blank",
                                                                                "noopener,noreferrer"
                                                                            );
                                                                        }
                                                                    }}
                                                                >
                                                                    <FaDownload />
                                                                </button>

                                                                {canManageSections && (
                                                                    <button
                                                                        type="button"
                                                                        className="danger"
                                                                        title="Delete resource"
                                                                        disabled={
                                                                            sectionResourceDeleting[
                                                                                resource
                                                                                    .id
                                                                            ]
                                                                        }
                                                                        onClick={() =>
                                                                            deleteSectionResource(
                                                                                section,
                                                                                resource
                                                                            )
                                                                        }
                                                                    >
                                                                        <FaTrash />
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                )}

                                                {(
                                                    sectionResources[
                                                        section.id
                                                    ] || []
                                                ).length ===
                                                    0 && (
                                                    <div className="cayep-no-video-resources">
                                                        No learning
                                                        resources
                                                        have been
                                                        attached
                                                        to this
                                                        video yet.
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>

                                {canManageSections && (
                                    <div className="cayep-video-card-actions">
                                        <button
                                            type="button"
                                            onClick={() =>
                                                beginSectionEdit(
                                                    section
                                                )
                                            }
                                            title="Edit video"
                                        >
                                            <FaEdit />
                                        </button>

                                        <button
                                            type="button"
                                            onClick={() =>
                                                deleteVideoSection(
                                                    section
                                                )
                                            }
                                            disabled={
                                                deletingSection
                                            }
                                            className="danger"
                                            title="Delete video"
                                        >
                                            <FaTrash />
                                        </button>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                );
            })
        ) : (
            selectedCourse.video && (
                <div className="cayep-no-sections">
                    <FaLayerGroup />

                    <strong>
                        No additional videos yet
                    </strong>

                    <p>
                        Add Video 2 and subsequent
                        learning sections using the
                        button above.
                    </p>
                </div>
            )
        )}
    </div>
</div>
                              


                                    {!selectedSection ? (
                                        <>
                                            <div className="cayep-editor-tabs">
                                                <button
                                                    type="button"
                                                    className={
                                                        activeEditor ===
                                                        "overview"
                                                            ? "active"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setActiveEditor(
                                                            "overview"
                                                        )
                                                    }
                                                >
                                                    <FaBookOpen />
                                                    Overview
                                                </button>

                                                <button
                                                    type="button"
                                                    className={
                                                        activeEditor ===
                                                        "announcement"
                                                            ? "active"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setActiveEditor(
                                                            "announcement"
                                                        )
                                                    }
                                                >
                                                    <FaBullhorn />
                                                    Announcement
                                                </button>

                                                <button
                                                    type="button"
                                                    className={
                                                        activeEditor ===
                                                        "review"
                                                            ? "active"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setActiveEditor(
                                                            "review"
                                                        )
                                                    }
                                                >
                                                    <FaStar />
                                                    Review
                                                </button>

                                                <button
                                                    type="button"
                                                    className={
                                                        activeEditor ===
                                                        "questions"
                                                            ? "active"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setActiveEditor(
                                                            "questions"
                                                        )
                                                    }
                                                >
                                                    <FaQuestionCircle />
                                                    Student
                                                    Q&A
                                                </button>
                                            </div>

                                            {activeEditor ===
                                                "overview" && (
                                                <div className="cayep-editor-panel">
                                                    <div className="cayep-editor-title">
                                                        <FaEdit />

                                                        <div>
                                                            <h3>
                                                                Course
                                                                Overview
                                                            </h3>

                                                            <p>
                                                                Write
                                                                the
                                                                overview
                                                                students
                                                                will
                                                                read for
                                                                the
                                                                course.
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <textarea
                                                        value={
                                                            overview
                                                        }
                                                        onChange={(
                                                            event
                                                        ) =>
                                                            setOverview(
                                                                event
                                                                    .target
                                                                    .value
                                                            )
                                                        }
                                                        rows={
                                                            12
                                                        }
                                                        placeholder="Explain what students will learn in this course..."
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={
                                                            saveOverview
                                                        }
                                                        disabled={
                                                            savingOverview ||
                                                            !overview.trim()
                                                        }
                                                    >
                                                        <FaSave />

                                                        {savingOverview
                                                            ? "Publishing..."
                                                            : "Publish Overview"}
                                                    </button>
                                                </div>
                                            )}

                                            {activeEditor ===
                                                "announcement" && (
                                                <div className="cayep-editor-panel">
                                                    <div className="cayep-editor-title">
                                                        <FaBullhorn />

                                                        <div>
                                                            <h3>
                                                                Course
                                                                Announcement
                                                            </h3>

                                                            <p>
                                                                Publish
                                                                an
                                                                update
                                                                students
                                                                will see
                                                                in the
                                                                course
                                                                classroom.
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <input
                                                        value={
                                                            announcementTitle
                                                        }
                                                        onChange={(
                                                            event
                                                        ) =>
                                                            setAnnouncementTitle(
                                                                event
                                                                    .target
                                                                    .value
                                                            )
                                                        }
                                                        placeholder="Announcement title"
                                                    />

                                                    <textarea
                                                        value={
                                                            announcementContent
                                                        }
                                                        onChange={(
                                                            event
                                                        ) =>
                                                            setAnnouncementContent(
                                                                event
                                                                    .target
                                                                    .value
                                                            )
                                                        }
                                                        rows={
                                                            9
                                                        }
                                                        placeholder="Write your announcement..."
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={
                                                            publishAnnouncement
                                                        }
                                                        disabled={
                                                            savingAnnouncement ||
                                                            !announcementTitle.trim() ||
                                                            !announcementContent.trim()
                                                        }
                                                    >
                                                        <FaPlus />

                                                        {savingAnnouncement
                                                            ? "Publishing..."
                                                            : "Publish Announcement"}
                                                    </button>
                                                </div>
                                            )}

                                            {activeEditor ===
                                                "review" && (
                                                <div className="cayep-editor-panel">
                                                    <div className="cayep-editor-title">
                                                        <FaStar />

                                                        <div>
                                                            <h3>
                                                                Instructor
                                                                Review
                                                            </h3>

                                                            <p>
                                                                Add
                                                                instructor
                                                                guidance
                                                                or a
                                                                review
                                                                for this
                                                                course.
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <textarea
                                                        value={
                                                            review
                                                        }
                                                        onChange={(
                                                            event
                                                        ) =>
                                                            setReview(
                                                                event
                                                                    .target
                                                                    .value
                                                            )
                                                        }
                                                        rows={
                                                            10
                                                        }
                                                        placeholder="Write your review or learning guidance..."
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={
                                                            publishReview
                                                        }
                                                        disabled={
                                                            savingReview ||
                                                            !review.trim()
                                                        }
                                                    >
                                                        <FaSave />

                                                        {savingReview
                                                            ? "Publishing..."
                                                            : "Publish Review"}
                                                    </button>
                                                </div>
                                            )}

                                            {activeEditor ===
                                                "questions" && (
                                                <div className="cayep-editor-panel">
                                                    <div className="cayep-editor-title">
                                                        <FaQuestionCircle />

                                                        <div>
                                                            <h3>
                                                                Student
                                                                Q&A
                                                            </h3>

                                                            <p>
                                                                Read
                                                                questions
                                                                and
                                                                student
                                                                discussion
                                                                for the
                                                                course.
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {classroom
                                                        ?.questions
                                                        ?.length ? (
                                                        classroom.questions.map(
                                                            (
                                                                item
                                                            ) => (
                                                                <div
                                                                    className="cayep-teacher-question"
                                                                    key={
                                                                        item.id
                                                                    }
                                                                >
                                                                    <strong>
                                                                        {item.student_name ||
                                                                            "Student"}
                                                                    </strong>

                                                                    <small>
                                                                        {item.created_at
                                                                            ? new Date(
                                                                                  item.created_at
                                                                              ).toLocaleString()
                                                                            : ""}
                                                                    </small>

                                                                    <p>
                                                                        {
                                                                            item.question
                                                                        }
                                                                    </p>

                                                                    {item
                                                                        .replies
                                                                        ?.length >
                                                                        0 && (
                                                                        <div>
                                                                            {item.replies.map(
                                                                                (
                                                                                    reply
                                                                                ) => (
                                                                                    <div
                                                                                        className="cayep-teacher-reply"
                                                                                        key={
                                                                                            reply.id
                                                                                        }
                                                                                    >
                                                                                        <strong>
                                                                                            {reply.student_name ||
                                                                                                "Student"}
                                                                                        </strong>

                                                                                        <p>
                                                                                            {
                                                                                                reply.reply
                                                                                            }
                                                                                        </p>
                                                                                    </div>
                                                                                )
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    <span className="cayep-read-only-badge">
                                                                        Teacher
                                                                        view —
                                                                        read
                                                                        only
                                                                    </span>
                                                                </div>
                                                            )
                                                        )
                                                    ) : (
                                                        <div className="cayep-workspace-empty small">
                                                            <FaQuestionCircle />

                                                            <h3>
                                                                No
                                                                Student
                                                                Questions
                                                            </h3>

                                                            <p>
                                                                Questions
                                                                submitted
                                                                by
                                                                students
                                                                will
                                                                appear
                                                                here.
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    ) : sectionClassroomLoading ? (
                                        <div className="cayep-section-classroom-loading">
                                            <FaVideo />

                                            <strong>
                                                Loading Video{" "}
                                                {
                                                    getSectionNumber(
                                                        selectedSection
                                                    )
                                                }{" "}
                                                Classroom
                                            </strong>

                                            <p>
                                                Please wait while
                                                the selected video
                                                classroom is loaded.
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="cayep-section-classroom">
                                            <div className="cayep-section-classroom-header">
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setSelectedSection(
                                                            null
                                                        );
                                                        setSectionClassroom(
                                                            null
                                                        );
                                                    }}
                                                >
                                                    <FaChevronLeft />
                                                    Back to Course
                                                </button>

                                                <div>
                                                    <span>
                                                        VIDEO CLASSROOM
                                                    </span>

                                                    <h3>
                                                        Video{" "}
                                                        {
                                                            getSectionNumber(
                                                                selectedSection
                                                            )
                                                        }
                                                        :{" "}
                                                        {
                                                            selectedSection.title
                                                        }
                                                    </h3>

                                                    <div className="cayep-section-header-meta">
                                                        <span>
                                                            <FaClock />
                                                            {selectedSectionDuration >
                                                            0
                                                                ? formatDuration(
                                                                      selectedSectionDuration
                                                                  )
                                                                : "Duration unavailable"}
                                                        </span>

                                                        <span>
                                                            <FaCheckCircle />
                                                            Course:
                                                            {" "}
                                                            {
                                                                selectedCourse.name
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>

                                            {selectedSection.video && (
                                                <div className="cayep-section-video-player">
                                                    <video
                                                        controls
                                                        preload="metadata"
                                                        src={getMediaUrl(
                                                            selectedSection.video
                                                        )}
                                                    >
                                                        Your browser
                                                        does not
                                                        support
                                                        HTML5 video.
                                                    </video>
                                                </div>
                                            )}

                                            <div className="cayep-section-classroom-tabs">
                                                <button
                                                    type="button"
                                                    className={
                                                        activeSectionEditor ===
                                                        "overview"
                                                            ? "active"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setActiveSectionEditor(
                                                            "overview"
                                                        )
                                                    }
                                                >
                                                    <FaBookOpen />
                                                    Overview
                                                </button>

                                                <button
                                                    type="button"
                                                    className={
                                                        activeSectionEditor ===
                                                        "announcement"
                                                            ? "active"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setActiveSectionEditor(
                                                            "announcement"
                                                        )
                                                    }
                                                >
                                                    <FaBullhorn />
                                                    Announcements
                                                </button>

                                                <button
                                                    type="button"
                                                    className={
                                                        activeSectionEditor ===
                                                        "review"
                                                            ? "active"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setActiveSectionEditor(
                                                            "review"
                                                        )
                                                    }
                                                >
                                                    <FaStar />
                                                    Reviews
                                                </button>

                                                <button
                                                    type="button"
                                                    className={
                                                        activeSectionEditor ===
                                                        "questions"
                                                            ? "active"
                                                            : ""
                                                    }
                                                    onClick={() =>
                                                        setActiveSectionEditor(
                                                            "questions"
                                                        )
                                                    }
                                                >
                                                    <FaQuestionCircle />
                                                    Student
                                                    Q&A
                                                </button>
                                            </div>

                                            {activeSectionEditor ===
                                                "overview" && (
                                                <div className="cayep-editor-panel">
                                                    <div className="cayep-editor-title">
                                                        <FaFileAlt />

                                                        <div>
                                                            <h3>
                                                                Video
                                                                Overview
                                                            </h3>

                                                            <p>
                                                                This
                                                                overview
                                                                belongs
                                                                only to
                                                                Video{" "}
                                                                {
                                                                    getSectionNumber(
                                                                        selectedSection
                                                                    )
                                                                }.
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <textarea
                                                        value={
                                                            sectionOverview
                                                        }
                                                        onChange={(
                                                            event
                                                        ) =>
                                                            setSectionOverview(
                                                                event
                                                                    .target
                                                                    .value
                                                            )
                                                        }
                                                        rows={
                                                            12
                                                        }
                                                        placeholder="Explain what learners will understand after completing this video..."
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={
                                                            saveSectionOverview
                                                        }
                                                        disabled={
                                                            savingSectionOverview ||
                                                            !sectionOverview.trim()
                                                        }
                                                    >
                                                        <FaSave />

                                                        {savingSectionOverview
                                                            ? "Publishing..."
                                                            : "Publish Video Overview"}
                                                    </button>
                                                </div>
                                            )}

                                            {activeSectionEditor ===
                                                "announcement" && (
                                                <div className="cayep-editor-panel">
                                                    <div className="cayep-editor-title">
                                                        <FaBullhorn />

                                                        <div>
                                                            <h3>
                                                                Video
                                                                Announcement
                                                            </h3>

                                                            <p>
                                                                Announcements
                                                                for this
                                                                video
                                                                section
                                                                remain
                                                                separate
                                                                from the
                                                                main
                                                                course.
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <input
                                                        value={
                                                            sectionAnnouncementTitle
                                                        }
                                                        onChange={(
                                                            event
                                                        ) =>
                                                            setSectionAnnouncementTitle(
                                                                event
                                                                    .target
                                                                    .value
                                                            )
                                                        }
                                                        placeholder="Announcement title"
                                                    />

                                                    <textarea
                                                        value={
                                                            sectionAnnouncementContent
                                                        }
                                                        onChange={(
                                                            event
                                                        ) =>
                                                            setSectionAnnouncementContent(
                                                                event
                                                                    .target
                                                                    .value
                                                            )
                                                        }
                                                        rows={
                                                            9
                                                        }
                                                        placeholder="Write an announcement for this video..."
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={
                                                            publishSectionAnnouncement
                                                        }
                                                        disabled={
                                                            savingSectionAnnouncement ||
                                                            !sectionAnnouncementTitle.trim() ||
                                                            !sectionAnnouncementContent.trim()
                                                        }
                                                    >
                                                        <FaPlus />

                                                        {savingSectionAnnouncement
                                                            ? "Publishing..."
                                                            : "Publish Announcement"}
                                                    </button>
                                                </div>
                                            )}

                                            {activeSectionEditor ===
                                                "review" && (
                                                <div className="cayep-editor-panel">
                                                    <div className="cayep-editor-title">
                                                        <FaStar />

                                                        <div>
                                                            <h3>
                                                                Video
                                                                Review
                                                            </h3>

                                                            <p>
                                                                Add
                                                                learning
                                                                guidance
                                                                or
                                                                instructor
                                                                commentary
                                                                for this
                                                                video.
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <textarea
                                                        value={
                                                            sectionReview
                                                        }
                                                        onChange={(
                                                            event
                                                        ) =>
                                                            setSectionReview(
                                                                event
                                                                    .target
                                                                    .value
                                                            )
                                                        }
                                                        rows={
                                                            10
                                                        }
                                                        placeholder="Write your review or learning guidance..."
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={
                                                            publishSectionReview
                                                        }
                                                        disabled={
                                                            savingSectionReview ||
                                                            !sectionReview.trim()
                                                        }
                                                    >
                                                        <FaSave />

                                                        {savingSectionReview
                                                            ? "Publishing..."
                                                            : "Publish Review"}
                                                    </button>
                                                </div>
                                            )}

                                            {activeSectionEditor ===
                                                "questions" && (
                                                <div className="cayep-editor-panel">
                                                    <div className="cayep-editor-title">
                                                        <FaQuestionCircle />

                                                        <div>
                                                            <h3>
                                                                Video
                                                                Student
                                                                Q&A
                                                            </h3>

                                                            <p>
                                                                Questions
                                                                and
                                                                replies
                                                                belonging
                                                                specifically
                                                                to this
                                                                video
                                                                section.
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {sectionClassroom
                                                        ?.questions
                                                        ?.length ? (
                                                        sectionClassroom.questions.map(
                                                            (
                                                                item
                                                            ) => (
                                                                <div
                                                                    className="cayep-teacher-question"
                                                                    key={
                                                                        item.id
                                                                    }
                                                                >
                                                                    <strong>
                                                                        {item.student_name ||
                                                                            "Student"}
                                                                    </strong>

                                                                    <small>
                                                                        {item.created_at
                                                                            ? new Date(
                                                                                  item.created_at
                                                                              ).toLocaleString()
                                                                            : ""}
                                                                    </small>

                                                                    <p>
                                                                        {
                                                                            item.question
                                                                        }
                                                                    </p>

                                                                    {item
                                                                        .replies
                                                                        ?.length >
                                                                        0 && (
                                                                        <div>
                                                                            {item.replies.map(
                                                                                (
                                                                                    reply
                                                                                ) => (
                                                                                    <div
                                                                                        className="cayep-teacher-reply"
                                                                                        key={
                                                                                            reply.id
                                                                                        }
                                                                                    >
                                                                                        <strong>
                                                                                            {reply.student_name ||
                                                                                                "Student"}
                                                                                        </strong>

                                                                                        <p>
                                                                                            {
                                                                                                reply.reply
                                                                                            }
                                                                                        </p>
                                                                                    </div>
                                                                                )
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    <span className="cayep-read-only-badge">
                                                                        Teacher
                                                                        view —
                                                                        read
                                                                        only
                                                                    </span>
                                                                </div>
                                                            )
                                                        )
                                                    ) : (
                                                        <div className="cayep-workspace-empty small">
                                                            <FaQuestionCircle />

                                                            <h3>
                                                                No
                                                                Questions
                                                                for This
                                                                Video
                                                            </h3>

                                                            <p>
                                                                Student
                                                                questions
                                                                for this
                                                                specific
                                                                video
                                                                section
                                                                will
                                                                appear
                                                                here.
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {renderPagination()}
                </>
            )}

            {editCourse && (
                <ViewCoursesEdit
                    course={editCourse}
                    canEdit={canEditCourses}
                    canDelete={canDeleteCourses}
                    userRole={userRole}
                    onClose={() =>
                        setEditCourse(null)
                    }
                    onUpdated={
                        handleCourseUpdated
                    }
                    onDeleted={
                        handleCourseDeleted
                    }
                    onDeleteDenied={
                        handleDeleteDenied
                    }
                    onConfirmDelete={
                        confirmCourseDelete
                    }
                />
            )}

            <style>{`
                .cayep-view-courses {
                    min-height: 100vh;
                    padding: 45px;
                    background:
                        linear-gradient(
                            135deg,
                            #07131d,
                            #062A4B
                        );
                    color: #F0EDEA;
                    font-family:
                        "Poppins",
                        "Inter",
                        Arial,
                        sans-serif;
                }

                .cayep-view-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 25px;
                    max-width: 1450px;
                    margin: 0 auto 25px;
                }

                .cayep-view-header > div:first-child > span {
                    color: #F6C944;
                    font-size: 9px;
                    font-weight: 800;
                    letter-spacing: 3px;
                }

                .cayep-view-header h1 {
                    margin: 7px 0;
                    font-size: 38px;
                }

                .cayep-view-header p {
                    margin: 0;
                    color: #929da2;
                    font-size: 13px;
                }

                .cayep-course-count {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 17px 22px;
                    border:
                        1px solid
                        rgba(246, 201, 68, 0.25);
                    background:
                        rgba(246, 201, 68, 0.04);
                }

                .cayep-course-count svg,
                .cayep-course-count strong {
                    color: #F6C944;
                }

                .cayep-course-count strong {
                    font-size: 23px;
                }

                .cayep-course-count span {
                    color: #929da2;
                    font-size: 10px;
                }

                .cayep-course-toolbar {
                    max-width: 1450px;
                    margin: 0 auto 20px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 18px;
                }

                .cayep-course-search {
                    width: min(100%, 560px);
                    min-height: 48px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 0 15px;
                    box-sizing: border-box;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.11);
                    background:
                        rgba(0, 0, 0, 0.16);
                }

                .cayep-course-search > svg {
                    flex-shrink: 0;
                    color: #F6C944;
                }

                .cayep-course-search input {
                    width: 100%;
                    border: 0;
                    outline: 0;
                    background: transparent;
                    color: #F0EDEA;
                    font-family: inherit;
                    font-size: 12px;
                }

                .cayep-course-search input::placeholder {
                    color: #667279;
                }

                .cayep-course-search > button {
                    width: 27px;
                    height: 27px;
                    flex-shrink: 0;
                    border: 0;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.08);
                    color: #AAB3B7;
                    cursor: pointer;
                    font-size: 17px;
                }

                .cayep-course-toolbar-info {
                    color: #8B979D;
                    font-size: 10px;
                    white-space: nowrap;
                }

                .cayep-teacher-course-layout {
                    display: grid;
                    grid-template-columns:
                        360px minmax(0, 1fr);
                    gap: 25px;
                    max-width: 1450px;
                    margin: auto;
                }

                .cayep-teacher-course-sidebar,
                .cayep-teacher-course-workspace {
                    min-width: 0;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.09);
                    background:
                        rgba(0, 0, 0, 0.13);
                }

                .cayep-course-list-heading {
                    padding: 18px;
                    border-bottom:
                        1px solid
                        rgba(240, 237, 234, 0.08);
                }

                .cayep-course-list-heading strong {
                    display: block;
                    font-size: 13px;
                }

                .cayep-course-list-heading small {
                    display: block;
                    margin-top: 4px;
                    color: #727E84;
                    font-size: 9px;
                }

                .cayep-teacher-course-list {
                    display: flex;
                    flex-direction: column;
                    gap: 1px;
                }

                .cayep-course-item {
                    display: flex;
                    align-items: stretch;
                    border-bottom:
                        1px solid
                        rgba(240, 237, 234, 0.055);
                    transition:
                        background 0.2s ease;
                }

                .cayep-course-item:hover,
                .cayep-course-item.active {
                    background:
                        rgba(246, 201, 68, 0.055);
                }

                .cayep-course-select {
                    display: flex;
                    flex: 1;
                    min-width: 0;
                    padding: 9px;
                    gap: 12px;
                    text-align: left;
                    border: 0;
                    background: transparent;
                    color: #F0EDEA;
                    cursor: pointer;
                    font-family: inherit;
                }

                .cayep-course-item-actions {
                    width: 86px;
                    flex-shrink: 0;
                    display: flex;
                    align-items: stretch;
                    border-left:
                        1px solid
                        rgba(240, 237, 234, 0.07);
                }

                .cayep-course-edit-button,
                .cayep-course-delete-button {
                    width: 43px;
                    flex-shrink: 0;
                    border: 0;
                    background: transparent;
                    cursor: pointer;
                    transition:
                        color 0.2s ease,
                        background 0.2s ease;
                }

                .cayep-course-edit-button {
                    color: #758187;
                    border-right:
                        1px solid
                        rgba(240, 237, 234, 0.07);
                }

                .cayep-course-edit-button:hover {
                    color: #F6C944;
                    background:
                        rgba(246, 201, 68, 0.08);
                }

                .cayep-course-delete-button {
                    color: #B87876;
                }

                .cayep-course-delete-button:hover {
                    color: #FFFFFF;
                    background:
                        rgba(185, 74, 72, 0.2);
                }

                .cayep-course-delete-button.restricted {
                    color: #8D7776;
                }

                .cayep-course-delete-button.restricted:hover {
                    color: #F6C944;
                    background:
                        rgba(246, 201, 68, 0.08);
                }

                .cayep-teacher-course-image {
                    position: relative;
                    width: 90px;
                    height: 70px;
                    flex-shrink: 0;
                    overflow: hidden;
                    display: grid;
                    place-items: center;
                    background: #063A6B;
                    color: #F6C944;
                }

                .cayep-teacher-course-image img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .cayep-teacher-course-image > span {
                    position: absolute;
                    right: 5px;
                    bottom: 5px;
                    width: 24px;
                    height: 24px;
                    display: grid;
                    place-items: center;
                    border-radius: 50%;
                    background: #F6C944;
                    color: #0A0F12;
                    font-size: 8px;
                }

                .cayep-teacher-course-info {
                    min-width: 0;
                    padding: 3px 0;
                }

                .cayep-teacher-course-info strong {
                    display: block;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 12px;
                }

                .cayep-teacher-course-info small {
                    display: block;
                    margin-top: 5px;
                    color: #717c82;
                    font-size: 9px;
                }

                .cayep-teacher-course-info > div {
                    display: flex;
                    gap: 10px;
                    margin-top: 8px;
                }

                .cayep-teacher-course-info > div span {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    color: #858f94;
                    font-size: 8px;
                }

                .cayep-teacher-course-info svg {
                    color: #F6C944;
                }

                .cayep-workspace-empty {
                    min-height: 600px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 35px;
                    text-align: center;
                    color: #737e84;
                }

                .cayep-workspace-empty.small {
                    min-height: 250px;
                }

                .cayep-workspace-empty svg {
                    margin-bottom: 18px;
                    color: #F6C944;
                    font-size: 35px;
                }

                .cayep-workspace-empty h3 {
                    margin: 0 0 8px;
                    color: #F0EDEA;
                }

                .cayep-workspace-empty p {
                    max-width: 450px;
                    margin: 0;
                    font-size: 12px;
                    line-height: 1.8;
                }

                .cayep-workspace-empty > button {
                    margin-top: 18px;
                    padding: 10px 17px;
                    border: 1px solid #F6C944;
                    background: #F6C944;
                    color: #0A0F12;
                    cursor: pointer;
                    font-family: inherit;
                    font-size: 10px;
                    font-weight: 800;
                }

                .cayep-workspace-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                    padding: 25px;
                    border-bottom:
                        1px solid
                        rgba(240, 237, 234, 0.08);
                }

                .cayep-workspace-header > div:first-child {
                    min-width: 0;
                }

                .cayep-workspace-header span {
                    color: #F6C944;
                    font-size: 8px;
                    font-weight: 800;
                    letter-spacing: 2px;
                }

                .cayep-workspace-header h2 {
                    margin: 6px 0 0;
                    font-size: 25px;
                    word-break: break-word;
                }

                .cayep-course-stat-row {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    flex-wrap: wrap;
                    margin-top: 13px;
                }

                .cayep-course-stat-row span,
                .cayep-preview-stats span {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    color: #8E999E;
                    font-size: 9px;
                }

                .cayep-course-stat-row svg,
                .cayep-preview-stats svg {
                    color: #F6C944;
                }

                .cayep-workspace-actions {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .cayep-video-badge,
                .cayep-workspace-edit,
                .cayep-workspace-delete,
                .cayep-teacher-permission-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 7px;
                    padding: 9px 12px;
                    font-size: 9px;
                    font-weight: 700;
                }

                .cayep-video-badge {
                    border:
                        1px solid
                        rgba(79, 174, 34, 0.3);
                    color: #8fd06e;
                    background:
                        rgba(79, 174, 34, 0.05);
                }

                .cayep-video-badge.warning {
                    border-color:
                        rgba(246, 201, 68, 0.28);
                    color: #F6C944;
                    background:
                        rgba(246, 201, 68, 0.05);
                }

                .cayep-workspace-edit {
                    border:
                        1px solid
                        rgba(246, 201, 68, 0.35);
                    background:
                        rgba(246, 201, 68, 0.07);
                    color: #F6C944;
                    cursor: pointer;
                    font-family: inherit;
                }

                .cayep-workspace-delete {
                    border:
                        1px solid
                        rgba(185, 74, 72, 0.38);
                    background:
                        rgba(185, 74, 72, 0.08);
                    color: #D88986;
                    cursor: pointer;
                    font-family: inherit;
                }

                .cayep-workspace-delete:disabled {
                    opacity: 0.45;
                    cursor: not-allowed;
                }

                .cayep-teacher-permission-badge {
                    border:
                        1px solid
                        rgba(79, 174, 34, 0.22);
                    background:
                        rgba(79, 174, 34, 0.05);
                    color: #8fd06e;
                }

                .cayep-teacher-preview {
                    display: flex;
                    gap: 20px;
                    margin: 20px;
                    padding: 15px;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.08);
                    background:
                        rgba(255, 255, 255, 0.025);
                }

                .cayep-teacher-preview img {
                    width: 180px;
                    height: 105px;
                    object-fit: cover;
                    flex-shrink: 0;
                }

                .cayep-preview-kicker,
                .cayep-video-card-kicker {
                    color: #F6C944;
                    font-size: 8px;
                    font-weight: 900;
                    letter-spacing: 1.7px;
                }

                .cayep-teacher-preview h3 {
                    margin: 6px 0 9px;
                    font-size: 18px;
                }

                .cayep-teacher-preview p {
                    margin: 0;
                    color: #8e989d;
                    font-size: 11px;
                    line-height: 1.7;
                }

                .cayep-preview-stats {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 14px;
                    margin-top: 13px;
                }

                .cayep-course-video-library {
                    margin: 20px;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.08);
                    background:
                        rgba(255, 255, 255, 0.018);
                }

                .cayep-video-library-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 20px;
                    padding: 22px;
                    border-bottom:
                        1px solid
                        rgba(240, 237, 234, 0.08);
                }

                .cayep-video-library-header > div {
                    min-width: 0;
                }

                .cayep-video-library-header > div > span {
                    color: #F6C944;
                    font-size: 8px;
                    font-weight: 900;
                    letter-spacing: 2px;
                }

                .cayep-video-library-header h3 {
                    margin: 5px 0;
                    font-size: 19px;
                }

                .cayep-video-library-header p {
                    margin: 0;
                    color: #7E898F;
                    font-size: 10px;
                    line-height: 1.7;
                }

                .cayep-add-video-button,
                .cayep-primary-action {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    min-height: 40px;
                    padding: 0 15px;
                    border: 1px solid #F6C944;
                    background: #F6C944;
                    color: #0A0F12;
                    cursor: pointer;
                    font-family: inherit;
                    font-size: 9px;
                    font-weight: 900;
                    white-space: nowrap;
                }

                .cayep-add-video-button:disabled,
                .cayep-primary-action:disabled {
                    opacity: 0.4;
                    cursor: not-allowed;
                }

                .cayep-video-required-notice {
                    display: flex;
                    gap: 13px;
                    margin: 16px;
                    padding: 15px;
                    border:
                        1px solid
                        rgba(246, 201, 68, 0.2);
                    background:
                        rgba(246, 201, 68, 0.045);
                }

                .cayep-video-required-notice > svg {
                    flex-shrink: 0;
                    margin-top: 2px;
                    color: #F6C944;
                }

                .cayep-video-required-notice strong {
                    display: block;
                    color: #E5D58D;
                    font-size: 10px;
                }

                .cayep-video-required-notice p {
                    margin: 5px 0 0;
                    color: #879298;
                    font-size: 9px;
                    line-height: 1.7;
                }

                .cayep-video-upload-panel {
                    margin: 16px;
                    padding: 20px;
                    border:
                        1px solid
                        rgba(246, 201, 68, 0.18);
                    background:
                        rgba(246, 201, 68, 0.025);
                }

                .cayep-section-panel-title {
                    display: flex;
                    align-items: flex-start;
                    gap: 13px;
                    margin-bottom: 18px;
                }

                .cayep-section-panel-title > div:nth-child(2) {
                    flex: 1;
                }

                .cayep-section-panel-title h4 {
                    margin: 0;
                    font-size: 15px;
                }

                .cayep-section-panel-title p {
                    margin: 5px 0 0;
                    color: #7D898F;
                    font-size: 9px;
                    line-height: 1.7;
                }

                .cayep-section-panel-title > button,
                .cayep-section-edit-header button {
                    border: 0;
                    background: transparent;
                    color: #78858B;
                    cursor: pointer;
                    font-size: 14px;
                }

                .cayep-section-number-badge {
                    width: 38px;
                    height: 38px;
                    display: grid;
                    place-items: center;
                    flex-shrink: 0;
                    background: rgba(246, 201, 68, 0.1);
                    border: 1px solid rgba(246, 201, 68, 0.22);
                    color: #F6C944;
                }

                .cayep-section-form-grid {
                    display: grid;
                    grid-template-columns:
                        minmax(0, 1fr)
                        minmax(0, 1fr);
                    gap: 14px;
                }

                .cayep-form-field {
                    min-width: 0;
                    margin-bottom: 14px;
                }

                .cayep-form-field label {
                    display: block;
                    margin-bottom: 7px;
                    color: #AEB7BB;
                    font-size: 9px;
                    font-weight: 700;
                }

                .cayep-form-field input,
                .cayep-form-field textarea,
                .cayep-section-edit-panel input,
                .cayep-section-edit-panel textarea {
                    width: 100%;
                    box-sizing: border-box;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.1);
                    outline: none;
                    background:
                        rgba(0, 0, 0, 0.18);
                    color: #F0EDEA;
                    padding: 12px;
                    font-family: inherit;
                    font-size: 10px;
                    line-height: 1.6;
                }

                .cayep-form-field input:focus,
                .cayep-form-field textarea:focus,
                .cayep-section-edit-panel input:focus,
                .cayep-section-edit-panel textarea:focus {
                    border-color: #F6C944;
                }

                .cayep-selected-file {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-top: 7px;
                    color: #8FD06E;
                    font-size: 8px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .cayep-section-form-actions,
                .cayep-section-edit-actions {
                    display: flex;
                    justify-content: flex-end;
                    gap: 9px;
                    margin-top: 5px;
                }

                .cayep-secondary-action {
                    min-height: 40px;
                    padding: 0 15px;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.12);
                    background:
                        rgba(255, 255, 255, 0.035);
                    color: #AEB7BB;
                    cursor: pointer;
                    font-family: inherit;
                    font-size: 9px;
                    font-weight: 700;
                }

                .cayep-secondary-action:disabled {
                    opacity: 0.4;
                    cursor: not-allowed;
                }

                .cayep-course-video-list {
                    display: flex;
                    flex-direction: column;
                    gap: 1px;
                }

                .cayep-video-card {
                    position: relative;
                    display: flex;
                    min-width: 0;
                    border-top:
                        1px solid
                        rgba(240, 237, 234, 0.055);
                    background:
                        rgba(0, 0, 0, 0.08);
                    transition:
                        background 0.2s ease;
                }

                .cayep-video-card:hover,
                .cayep-video-card.selected {
                    background:
                        rgba(246, 201, 68, 0.045);
                }

                .cayep-video-card-main {
                    display: flex;
                    align-items: center;
                    gap: 13px;
                    flex: 1;
                    min-width: 0;
                    padding: 14px;
                    border: 0;
                    background: transparent;
                    color: #F0EDEA;
                    text-align: left;
                    cursor: pointer;
                    font-family: inherit;
                }

                .cayep-video-number {
                    width: 34px;
                    height: 34px;
                    display: grid;
                    place-items: center;
                    flex-shrink: 0;
                    border:
                        1px solid
                        rgba(246, 201, 68, 0.18);
                    background:
                        rgba(246, 201, 68, 0.045);
                    color: #F6C944;
                    font-size: 11px;
                    font-weight: 900;
                }

                .cayep-video-number.main {
                    background: #F6C944;
                    color: #0A0F12;
                }

                .cayep-video-thumbnail {
                    position: relative;
                    width: 125px;
                    height: 75px;
                    flex-shrink: 0;
                    display: grid;
                    place-items: center;
                    overflow: hidden;
                    background: #063A6B;
                    color: #F6C944;
                }

                .cayep-video-thumbnail img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .cayep-video-thumbnail > span {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform:
                        translate(
                            -50%,
                            -50%
                        );
                    width: 31px;
                    height: 31px;
                    display: grid;
                    place-items: center;
                    border-radius: 50%;
                    background:
                        rgba(246, 201, 68, 0.94);
                    color: #0A0F12;
                    font-size: 9px;
                }

                .cayep-video-card-content {
                    min-width: 0;
                    flex: 1;
                }

                .cayep-video-card-content h4 {
                    margin: 4px 0 5px;
                    color: #F0EDEA;
                    font-size: 13px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .cayep-video-card-content p {
                    margin: 0;
                    color: #7F8B91;
                    font-size: 9px;
                    line-height: 1.65;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

                .cayep-video-card-meta {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 12px;
                    margin-top: 8px;
                }

                .cayep-video-card-meta span {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    color: #8B969B;
                    font-size: 8px;
                }

                .cayep-video-card-meta svg {
                    color: #F6C944;
                }

                .cayep-video-card-meta .published {
                    color: #8FD06E;
                }

                .cayep-video-card-meta .published svg {
                    color: #8FD06E;
                }

                .cayep-video-card-actions {
                    width: 82px;
                    flex-shrink: 0;
                    display: flex;
                    align-items: stretch;
                    border-left:
                        1px solid
                        rgba(240, 237, 234, 0.055);
                }

                .cayep-video-card-actions button {
                    flex: 1;
                    border: 0;
                    background: transparent;
                    color: #758187;
                    cursor: pointer;
                }

                .cayep-video-card-actions button:hover {
                    color: #F6C944;
                    background:
                        rgba(246, 201, 68, 0.07);
                }

                .cayep-video-card-actions button.danger {
                    color: #B87876;
                    border-left:
                        1px solid
                        rgba(240, 237, 234, 0.055);
                }

                .cayep-video-card-actions button.danger:hover {
                    color: #FFFFFF;
                    background:
                        rgba(185, 74, 72, 0.18);
                }

                .cayep-video-card-actions button:disabled {
                    opacity: 0.4;
                    cursor: not-allowed;
                }

                .cayep-video-duration-bar {
                    position: absolute;
                    right: 14px;
                    bottom: 8px;
                    color: #68757B;
                    font-size: 7px;
                }

                .cayep-section-edit-panel {
                    width: 100%;
                    box-sizing: border-box;
                    padding: 18px;
                }

                .cayep-section-edit-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 13px;
                }

                .cayep-section-edit-header strong {
                    color: #F6C944;
                    font-size: 11px;
                }

                .cayep-section-edit-panel input,
                .cayep-section-edit-panel textarea {
                    margin-bottom: 10px;
                }

                .cayep-video-list-loading,
                .cayep-no-sections {
                    min-height: 130px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    color: #707C82;
                    text-align: center;
                }

                .cayep-video-list-loading svg,
                .cayep-no-sections svg {
                    color: #F6C944;
                    font-size: 25px;
                }

                .cayep-video-list-loading span,
                .cayep-no-sections strong {
                    font-size: 10px;
                }

                .cayep-no-sections p {
                    margin: 0;
                    max-width: 350px;
                    color: #69767C;
                    font-size: 9px;
                    line-height: 1.7;
                }

                .cayep-editor-tabs,
                .cayep-section-classroom-tabs {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 1px;
                    padding: 0 20px;
                    border-bottom:
                        1px solid
                        rgba(240, 237, 234, 0.08);
                }

                .cayep-editor-tabs button,
                .cayep-section-classroom-tabs button {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 15px 17px;
                    border: 0;
                    border-bottom:
                        2px solid transparent;
                    background: transparent;
                    color: #7e898f;
                    cursor: pointer;
                    font-family: inherit;
                    font-size: 10px;
                    font-weight: 700;
                }

                .cayep-editor-tabs button.active,
                .cayep-editor-tabs button:hover,
                .cayep-section-classroom-tabs button.active,
                .cayep-section-classroom-tabs button:hover {
                    color: #F6C944;
                    border-bottom-color:
                        #F6C944;
                }

                .cayep-editor-panel {
                    padding: 30px;
                }

                .cayep-editor-title {
                    display: flex;
                    gap: 13px;
                    margin-bottom: 20px;
                }

                .cayep-editor-title > svg {
                    color: #F6C944;
                    font-size: 22px;
                    margin-top: 3px;
                    flex-shrink: 0;
                }

                .cayep-editor-title h3 {
                    margin: 0;
                    font-size: 18px;
                }

                .cayep-editor-title p {
                    margin: 5px 0 0;
                    color: #808b91;
                    font-size: 11px;
                    line-height: 1.6;
                }

                .cayep-editor-panel textarea,
                .cayep-editor-panel input {
                    width: 100%;
                    box-sizing: border-box;
                    margin-bottom: 15px;
                    padding: 15px;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.12);
                    outline: none;
                    background:
                        rgba(255, 255, 255, 0.035);
                    color: #F0EDEA;
                    font-family: inherit;
                    font-size: 12px;
                    line-height: 1.7;
                }

                .cayep-editor-panel textarea:focus,
                .cayep-editor-panel input:focus {
                    border-color: #F6C944;
                }

                .cayep-editor-panel > button {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 12px 18px;
                    border: 1px solid #F6C944;
                    background: #F6C944;
                    color: #0A0F12;
                    cursor: pointer;
                    font-family: inherit;
                    font-size: 10px;
                    font-weight: 800;
                }

                .cayep-editor-panel > button:disabled {
                    opacity: 0.45;
                    cursor: not-allowed;
                }

                .cayep-section-classroom-loading {
                    min-height: 300px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    color: #7C888E;
                }

                .cayep-section-classroom-loading svg {
                    margin-bottom: 15px;
                    color: #F6C944;
                    font-size: 32px;
                }

                .cayep-section-classroom-loading strong {
                    color: #F0EDEA;
                    font-size: 14px;
                }

                .cayep-section-classroom-loading p {
                    margin: 7px 0 0;
                    font-size: 10px;
                }

                .cayep-section-classroom-header {
                    display: grid;
                    grid-template-columns: auto minmax(0, 1fr);
                    gap: 20px;
                    padding: 22px 25px;
                    border-bottom:
                        1px solid
                        rgba(240, 237, 234, 0.08);
                }

                .cayep-section-classroom-header > button {
                    align-self: start;
                    display: inline-flex;
                    align-items: center;
                    gap: 7px;
                    padding: 9px 12px;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.1);
                    background:
                        rgba(255, 255, 255, 0.035);
                    color: #9DA8AD;
                    cursor: pointer;
                    font-family: inherit;
                    font-size: 9px;
                    font-weight: 700;
                }

                .cayep-section-classroom-header > div > span {
                    color: #F6C944;
                    font-size: 8px;
                    font-weight: 900;
                    letter-spacing: 2px;
                }

                .cayep-section-classroom-header h3 {
                    margin: 5px 0 8px;
                    font-size: 20px;
                    word-break: break-word;
                }

                .cayep-section-header-meta {
                    display: flex;
                    gap: 15px;
                    flex-wrap: wrap;
                }

                .cayep-section-header-meta span {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    color: #7D898F;
                    font-size: 8px;
                }

                .cayep-section-header-meta svg {
                    color: #F6C944;
                }

                .cayep-section-video-player {
                    margin: 20px;
                    background: #000;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.1);
                }

                .cayep-section-video-player video {
                    display: block;
                    width: 100%;
                    max-height: 560px;
                    background: #000;
                }

                .cayep-teacher-question {
                    padding: 20px;
                    margin-bottom: 12px;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.08);
                    background:
                        rgba(255, 255, 255, 0.025);
                }

                .cayep-teacher-question strong {
                    color: #F0EDEA;
                    font-size: 12px;
                }

                .cayep-teacher-question > small {
                    display: block;
                    margin-top: 3px;
                    color: #687278;
                    font-size: 8px;
                }

                .cayep-teacher-question > p {
                    margin: 12px 0;
                    color: #aeb7bb;
                    line-height: 1.7;
                    font-size: 12px;
                }

                .cayep-teacher-reply {
                    margin-top: 8px;
                    padding: 10px 12px;
                    border-left:
                        2px solid
                        rgba(246, 201, 68, 0.3);
                    background:
                        rgba(246, 201, 68, 0.025);
                }

                .cayep-teacher-reply p {
                    margin: 5px 0 0;
                    color: #899499;
                    font-size: 11px;
                }

                .cayep-read-only-badge {
                    display: inline-block;
                    margin-top: 12px;
                    padding: 5px 8px;
                    color: #F6C944;
                    border:
                        1px solid
                        rgba(246, 201, 68, 0.2);
                    font-size: 8px;
                    font-weight: 700;
                }

                .cayep-course-pagination {
                    max-width: 1450px;
                    margin: 25px auto 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    flex-wrap: wrap;
                }

                .cayep-course-pagination button {
                    min-width: 38px;
                    min-height: 36px;
                    padding: 0 12px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.1);
                    background:
                        rgba(255, 255, 255, 0.035);
                    color: #A8B1B5;
                    cursor: pointer;
                    font-family: inherit;
                    font-size: 10px;
                    font-weight: 700;
                }

                .cayep-course-pagination button:hover:not(:disabled),
                .cayep-course-pagination button.active {
                    border-color: #F6C944;
                    background: #F6C944;
                    color: #0A0F12;
                }

                .cayep-course-pagination button:disabled {
                    opacity: 0.35;
                    cursor: not-allowed;
                }

                .cayep-course-pagination span {
                    color: #657178;
                    padding: 0 4px;
                }

                .cayep-view-state {
                    max-width: 1450px;
                    min-height: 430px;
                    margin: auto;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 40px;
                    text-align: center;
                    border:
                        1px solid
                        rgba(240, 237, 234, 0.08);
                    background:
                        rgba(0, 0, 0, 0.12);
                }

                .cayep-view-state > svg {
                    margin-bottom: 16px;
                    color: #F6C944;
                    font-size: 38px;
                }

                .cayep-view-state h3 {
                    margin: 0 0 8px;
                    font-size: 18px;
                }

                .cayep-view-state p {
                    margin: 0;
                    color: #79858B;
                    font-size: 11px;
                }

                .cayep-swal-popup {
                    border:
                        1px solid
                        rgba(246, 201, 68, 0.18) !important;
                    border-radius: 16px !important;
                    box-shadow:
                        0 25px 80px
                        rgba(0, 0, 0, 0.55) !important;
                    overflow: hidden !important;
                }

                .cayep-swal-title {
                    color: #F0EDEA !important;
                    font-family:
                        "Poppins",
                        "Inter",
                        Arial,
                        sans-serif !important;
                    font-size: 21px !important;
                    font-weight: 800 !important;
                }

                .cayep-swal-text,
                .cayep-swal-html {
                    color: #9DA8AD !important;
                    font-family:
                        "Poppins",
                        "Inter",
                        Arial,
                        sans-serif !important;
                    font-size: 12px !important;
                    white-space: pre-line;
                }

                .cayep-swal-message {
                    max-width: 430px;
                    margin: 0 auto;
                }

                .cayep-swal-icon-wrap {
                    width: 58px;
                    height: 58px;
                    margin: 4px auto 16px;
                    display: grid;
                    place-items: center;
                    border:
                        1px solid
                        rgba(246, 201, 68, 0.28);
                    border-radius: 50%;
                    background:
                        rgba(246, 201, 68, 0.07);
                    font-size: 24px;
                }

                .cayep-swal-message p {
                    margin: 0 0 10px;
                    color: #AAB4B8;
                    line-height: 1.8;
                }

                .cayep-swal-message p strong {
                    color: #F0EDEA;
                }

                .cayep-swal-notice {
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                    margin-top: 18px;
                    padding: 14px;
                    border:
                        1px solid
                        rgba(246, 201, 68, 0.18);
                    background:
                        rgba(246, 201, 68, 0.045);
                    text-align: left;
                }

                .cayep-swal-notice span {
                    color: #F6C944;
                    font-size: 8px;
                    font-weight: 900;
                    letter-spacing: 2px;
                }

                .cayep-swal-notice strong {
                    color: #D7DEE1;
                    font-size: 11px;
                    line-height: 1.6;
                }

                .cayep-delete-course-name {
                    margin: 0 auto 16px;
                    padding: 13px 15px;
                    border:
                        1px solid
                        rgba(239, 168, 28, 0.2);
                    background:
                        rgba(239, 168, 28, 0.06);
                    color: #F6C944;
                    font-size: 14px;
                    font-weight: 800;
                    word-break: break-word;
                }

                .cayep-swal-warning-box {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 9px;
                    margin-top: 16px;
                    padding: 11px;
                    border:
                        1px solid
                        rgba(229, 115, 115, 0.18);
                    background:
                        rgba(229, 115, 115, 0.045);
                    color: #E9B1B1;
                    font-size: 10px;
                }

                .cayep-swal-warning-box span {
                    color: #E57373;
                    font-size: 16px;
                }

                .cayep-delete-success-icon {
                    width: 58px;
                    height: 58px;
                    margin: 5px auto 16px;
                    display: grid;
                    place-items: center;
                    border:
                        1px solid
                        rgba(79, 174, 34, 0.3);
                    border-radius: 50%;
                    background:
                        rgba(79, 174, 34, 0.08);
                    color: #8FD06E;
                    font-size: 28px;
                    font-weight: 900;
                }

                .cayep-swal-button {
                    min-width: 120px;
                    margin: 5px;
                    padding: 11px 17px;
                    border: 0;
                    border-radius: 7px;
                    cursor: pointer;
                    font-family:
                        "Poppins",
                        "Inter",
                        Arial,
                        sans-serif;
                    font-size: 10px;
                    font-weight: 800;
                    transition:
                        transform 0.2s ease,
                        opacity 0.2s ease,
                        background 0.2s ease;
                }

                .cayep-swal-button:hover {
                    transform: translateY(-1px);
                }

                .cayep-swal-button-warning {
                    background: #F6C944;
                    color: #0A0F12;
                }

                .cayep-swal-button-danger {
                    background: #B94A48;
                    color: #FFFFFF;
                }

                .cayep-swal-button-danger:hover {
                    background: #963B39;
                }

                .cayep-swal-button-success {
                    background: #4FAE22;
                    color: #FFFFFF;
                }

                .cayep-swal-button-cancel {
                    background:
                        rgba(255, 255, 255, 0.08);
                    color: #C5CDD0;
                    border:
                        1px solid
                        rgba(255, 255, 255, 0.1);
                }

                @media (max-width: 1150px) {
                    .cayep-teacher-course-layout {
                        grid-template-columns:
                            310px minmax(0, 1fr);
                    }

                    .cayep-video-thumbnail {
                        width: 105px;
                    }
                }

                @media (max-width: 950px) {
                    .cayep-view-courses {
                        padding: 30px 20px;
                    }

                    .cayep-teacher-course-layout {
                        grid-template-columns: 1fr;
                    }

                    .cayep-teacher-course-list {
                        display: grid;
                        grid-template-columns:
                            repeat(
                                2,
                                minmax(0, 1fr)
                            );
                    }

                    .cayep-course-list-heading {
                        grid-column: 1 / -1;
                    }

                    .cayep-workspace-empty {
                        min-height: 350px;
                    }
                }

                @media (max-width: 750px) {
                    .cayep-video-library-header {
                        align-items: flex-start;
                        flex-direction: column;
                    }

                    .cayep-add-video-button {
                        width: 100%;
                    }

                    .cayep-section-form-grid {
                        grid-template-columns: 1fr;
                    }

                    .cayep-video-card-main {
                        align-items: flex-start;
                    }

                    .cayep-video-thumbnail {
                        width: 105px;
                        height: 68px;
                    }

                    .cayep-video-duration-bar {
                        position: static;
                        padding:
                            0 14px 10px
                            0;
                        margin-left: 47px;
                    }
                }

                @media (max-width: 700px) {
                    .cayep-view-header,
                    .cayep-course-toolbar {
                        align-items: flex-start;
                        flex-direction: column;
                    }

                    .cayep-course-search {
                        width: 100%;
                    }

                    .cayep-course-toolbar-info {
                        white-space: normal;
                    }

                    .cayep-teacher-course-list {
                        grid-template-columns: 1fr;
                    }

                    .cayep-section-classroom-header {
                        grid-template-columns: 1fr;
                    }

                    .cayep-section-classroom-header > button {
                        width: fit-content;
                    }
                }

                @media (max-width: 650px) {
                    .cayep-view-courses {
                        padding: 25px 14px;
                    }

                    .cayep-view-header h1 {
                        font-size: 31px;
                    }

                    .cayep-workspace-header {
                        align-items: flex-start;
                        flex-direction: column;
                    }

                    .cayep-workspace-actions {
                        width: 100%;
                    }

                    .cayep-teacher-preview {
                        flex-direction: column;
                    }

                    .cayep-teacher-preview img {
                        width: 100%;
                        height: 180px;
                    }

                    .cayep-editor-tabs,
                    .cayep-section-classroom-tabs {
                        overflow-x: auto;
                        flex-wrap: nowrap;
                    }

                    .cayep-editor-tabs button,
                    .cayep-section-classroom-tabs button {
                        white-space: nowrap;
                    }

                    .cayep-editor-panel {
                        padding: 20px 16px;
                    }

                    .cayep-course-video-library {
                        margin: 12px;
                    }

                    .cayep-video-card-main {
                        padding: 12px;
                        gap: 9px;
                    }

                    .cayep-video-number {
                        width: 28px;
                        height: 28px;
                        font-size: 9px;
                    }

                    .cayep-video-thumbnail {
                        width: 85px;
                        height: 60px;
                    }

                    .cayep-video-thumbnail > span {
                        width: 26px;
                        height: 26px;
                    }

                    .cayep-video-card-content h4 {
                        font-size: 11px;
                    }

                    .cayep-video-card-content p {
                        -webkit-line-clamp: 2;
                    }

                    .cayep-video-card-actions {
                        width: 66px;
                    }

                    .cayep-course-item-actions {
                        width: 80px;
                    }

                    .cayep-course-edit-button,
                    .cayep-course-delete-button {
                        width: 40px;
                    }

                    .cayep-section-video-player {
                        margin: 12px;
                    }

                    .cayep-section-video-player video {
                        max-height: 360px;
                    }

                    .cayep-section-form-actions,
                    .cayep-section-edit-actions {
                        flex-direction: column;
                    }

                    .cayep-section-form-actions button,
                    .cayep-section-edit-actions button {
                        width: 100%;
                    }
                }

                @media (max-width: 450px) {
                    .cayep-view-header h1 {
                        font-size: 27px;
                    }

                    .cayep-course-count {
                        width: 100%;
                        box-sizing: border-box;
                    }

                    .cayep-video-thumbnail {
                        width: 72px;
                        height: 55px;
                    }

                    .cayep-video-card-meta {
                        gap: 7px;
                    }

                    .cayep-video-card-meta span {
                        font-size: 7px;
                    }

                    .cayep-video-card-actions {
                        width: 58px;
                    }
                }

            
.cayep-video-resources {
    margin: 14px 18px 18px;
    padding: 15px;
    background: #F7F9FB;
    border: 1px solid #E0E7EC;
    border-radius: 13px;
    position: relative;
    z-index: 1;
}

.cayep-video-resources-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.cayep-resource-kicker {
    display: block;
    color: #0F6DAB;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 1px;
    margin-bottom: 4px;
}

.cayep-video-resources-header h5 {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 7px;
    color: #062A4B;
    font-size: 14px;
    font-weight: 800;
}

.cayep-video-resources-header h5 svg {
    color: #C0750D;
}

.cayep-resource-toggle {
    border: 1px solid #063A6B;
    background: #063A6B;
    color: #FFFFFF;
    border-radius: 8px;
    padding: 8px 12px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    flex-shrink: 0;
}

.cayep-resource-toggle:hover {
    background: #062A4B;
}

.cayep-video-resource-upload {
    margin-top: 14px;
    padding: 15px;
    background: #FFFFFF;
    border: 1px solid #DCE5EB;
    border-radius: 11px;
    position: relative;
    z-index: 2;
    overflow: visible;
}

.cayep-resource-form-grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 13px;
    row-gap: 13px;
    align-items: start;
    width: 100%;
    min-width: 0;
}

.cayep-form-field {
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-width: 0;
    width: 100%;
    position: relative;
    box-sizing: border-box;
}

.cayep-form-field label {
    color: #142536;
    font-size: 12px;
    font-weight: 800;
    line-height: 1.35;
}

.cayep-form-field input,
.cayep-form-field textarea {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    border: 1px solid #D5DEE5;
    border-radius: 8px;
    padding: 10px 11px;
    background: #FFFFFF;
    color: #142536;
    font-family: inherit;
    font-size: 13px;
    outline: none;
    position: relative;
    z-index: 1;
}

.cayep-form-field input:focus,
.cayep-form-field textarea:focus {
    border-color: #0F6DAB;
    box-shadow: 0 0 0 3px rgba(15, 109, 171, 0.08);
    z-index: 2;
}

.cayep-form-field textarea {
    display: block;
    min-height: 86px;
    resize: vertical;
    line-height: 1.45;
}

.cayep-selected-resource-file {
    margin-top: 8px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 9px 10px;
    background: #F2F8FC;
    border: 1px solid #D8E8F2;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    z-index: 1;
}

.cayep-selected-resource-file > svg {
    color: #0F6DAB;
    flex-shrink: 0;
}

.cayep-selected-resource-file > div {
    min-width: 0;
    flex: 1 1 auto;
    width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: hidden;
}

.cayep-selected-resource-file strong {
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #142536;
    font-size: 12px;
    line-height: 1.35;
}

.cayep-selected-resource-file span {
    display: block;
    color: #6B7280;
    font-size: 11px;
    line-height: 1.3;
}

.cayep-selected-resource-file button {
    width: 28px;
    height: 28px;
    min-width: 28px;
    border: 0;
    border-radius: 6px;
    background: #FFF1F1;
    color: #C62828;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.cayep-selected-resource-file button:hover {
    background: #FFE2E2;
}

.cayep-resource-description-field {
    grid-column: 1 / -1;
    width: 100%;
    min-width: 0;
}

.cayep-resource-form-actions {
    grid-column: 1 / -1;
    width: 100%;
    margin-top: 0;
    padding-top: 2px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    box-sizing: border-box;
}

.cayep-resource-form-actions button {
    border: 0;
    border-radius: 8px;
    padding: 9px 14px;
    font-size: 12px;
    font-weight: 800;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 7px;
}

.cayep-resource-form-actions .cayep-secondary-action {
    background: #EEF2F5;
    color: #526273;
}

.cayep-resource-form-actions .cayep-primary-action {
    background: #062A4B;
    color: #FFFFFF;
}

.cayep-resource-form-actions .cayep-secondary-action:hover {
    background: #E3E8EC;
}

.cayep-resource-form-actions .cayep-primary-action:hover {
    background: #063A6B;
}

.cayep-resource-form-actions button:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.cayep-video-resource-list {
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.cayep-resource-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    background: #FFFFFF;
    border: 1px solid #E0E7EC;
    border-radius: 9px;
    min-width: 0;
    box-sizing: border-box;
}

.cayep-resource-icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: #EEF5FA;
    color: #0F6DAB;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.cayep-resource-info {
    min-width: 0;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: hidden;
}

.cayep-resource-info strong {
    color: #142536;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cayep-resource-info span {
    color: #6B7280;
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cayep-resource-info small {
    color: #7A8793;
    font-size: 10px;
    line-height: 1.4;
    overflow-wrap: anywhere;
}

.cayep-resource-actions {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-shrink: 0;
}

.cayep-resource-actions button {
    width: 31px;
    height: 31px;
    border: 0;
    border-radius: 7px;
    background: #EEF3F7;
    color: #063A6B;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cayep-resource-actions button:hover {
    background: #DDEAF2;
}

.cayep-resource-actions button.danger {
    background: #FFF1F1;
    color: #C62828;
}

.cayep-resource-actions button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.cayep-resource-loading,
.cayep-no-video-resources {
    padding: 12px;
    text-align: center;
    color: #7A8793;
    font-size: 11px;
}

@media (max-width: 700px) {
    .cayep-resource-form-grid {
        grid-template-columns: 1fr;
        row-gap: 13px;
    }

    .cayep-resource-description-field,
    .cayep-resource-form-actions {
        grid-column: 1;
    }

    .cayep-video-resources-header {
        align-items: flex-start;
        flex-direction: column;
    }

    .cayep-resource-toggle {
        width: 100%;
        justify-content: center;
    }

    .cayep-resource-item {
        align-items: flex-start;
    }

    .cayep-resource-actions {
        margin-left: auto;
    }

    .cayep-resource-form-actions {
        flex-wrap: wrap;
    }
}

@media (max-width: 480px) {
    .cayep-video-resources {
        margin: 12px 10px 15px;
        padding: 12px;
    }

    .cayep-video-resource-upload {
        padding: 12px;
    }

    .cayep-selected-resource-file {
        padding: 8px;
    }

    .cayep-resource-form-actions {
        flex-direction: column;
    }

    .cayep-resource-form-actions button {
        width: 100%;
        justify-content: center;
    }
}


  
    .cayep-swal-popup {
    width: min(430px, calc(100vw - 28px)) !important;
    border-radius: 18px !important;
    padding: 24px !important;
    font-family: inherit !important;
}

.cayep-swal-title {
    color: #062A4B !important;
    font-size: 20px !important;
    font-weight: 800 !important;
    margin-top: 4px !important;
}

.cayep-swal-text {
    color: #526273 !important;
    font-size: 14px !important;
    line-height: 1.65 !important;
}

.cayep-swal-confirm {
    min-width: 110px !important;
    min-height: 40px !important;
    border-radius: 9px !important;
    font-weight: 700 !important;
    border: 0 !important;
}

.swal2-icon {
    margin-top: 2px !important;
}

.swal2-timer-progress-bar {
    background: #F6C944 !important;
}

            `}</style>
        </div>
    );
};

export default ViewCourses;

